import { LocaleMessageObject } from 'vue-i18n';

const en: LocaleMessageObject = {
    message: {
        one: "Test message"
    },
    shared: {
        button: {
            add: "Add",
            "add-new": "Add New",
            archive: "Archive",
            cancel: "Cancel",
            close: "Close",
            create: "Create",
            delete: "Delete",
            edit: "Edit",
            export: "Export",
            import: "Import",
            restore: "Restore",
            save: "Save",
            upload: "Upload",
            "upload-file": "Upload File",
            update: "Update",
            next: "Next",
            back: "Back",
            done: "Done",
            complete: "Complete",
            "abandon-changes": "Abandon Changes",
            "download-template": "Download Template"
        },
        label: {
            crew: "Crew",
            filter: "Filter",
            from: "from",
            leave: "Leave",
            "major-service": "Major Service",
            "minor-service": "Minor Service",
            name: "Name",
            overtime: "Overtime",
            role: "Role",
            service: "Service",
            unserviceable: "Unserviceable",
            "weekly-service": "Weekly Service",
            action: "Action",
            comments: "Comments",
            description: "Description",
            "not-saved": "Not Saved"
        },
        message: {
            "no-connection": "No Connection",
            "shift-planning-not-started": "Planning for this shift has not started",
            "week-planning-not-started": "Planning for this week has not started",
            "select-a": "Select a {term}",
            "error-saving": "There was an error saving"
        },
        concept: {
            shift: "Shift",
            cycle: "Cycle",
            task: "Task"
        },
        heading: {
            "add-term": "Add {term}",
            "create-term": "Create {term}",
            "create-term-2": "Create {term1} {term2}",
            "edit-term": "Edit {term}",
            "select-term": "Select {term}",
            "term-details": "{term} Details",
            "update-term-status": "Update {term} Status",
            "update-term-status-detail": "Update {term} Status - {detail}",
            "update-term-2": "Update {term1} - {term2}",
            "availability-for": "Availability For {name}"
        },
        validation: {
            "must-not-match-existing-name": "Must not match existing name.",
            "must-not-match-existing-code": "Must not match existing code.",
            "must-not-match-existing-short-name": "Must not match existing short name.",
            "must-be-unique": "Must be unique",
            "maximum-1-decimal-point": "Maximum 1 decimal point",
            "not-negative": "Not Negative"
        }
    },
    equipment: {
        "archived-term": "Archived {term}",
        "mark-as-serviceable": "Mark as Serviceable",
        "mark-as-unserviceable": "Mark as Unserviceable",
        "show-conflicts": "Show Conflicts"
    },
    "equipment-availability-dialog": {
        heading: "Equipment Availability"
    },
    actuals: {
        "error-saving-please-try-again": "Error has occured with saving: {errors}. Please try again.",
        "end-date": "End Date",
        "export-data-by-date-range": "Export data by date range",
        "export-data-for-current-shift-not-implemented": "Export data for current shift (not implemented)",
        "start-date": "Start Date",
        "plod-entry": "Plod Entry",
        "key-physicals": "Key Physicals",
        inspections: "Inspections",
        download: "Download",
        "read-only": "Read Only",
        editing: "Editing",
        "clear-data": "Clear Data",
        "export-to-csv": "Export to CSV",
        "enter-edit-mode": "Enter Edit Mode",
        "save-and-exit": "Save And Exit",
        "actuals-entry": "Actuals Entry",
        "confirm-clear-data": "Are you sure you want to clear all actuals data for this shift? This will permanently delete all Plod Entry, Key Physicals, and Equipment Downtime data.",
        "this-action-cannot-be-undone": "This action cannot be undone.",
        "successfully-cleared-data": "Successfully cleared all data for shift.",
        "error-clearing-data": "Error while clearing data for shift."
    },
    "actuals-definition-groups": {
        "assigned-actuals-definitions": "Assigned Actuals Definitions",
        "actuals-definition-groups": "Actuals Definition Groups",
        "archived-groups": "Archived Groups",
        "actuals-definitions-sort-order": "Actuals Definitions Sort Order",
        "assigned-task-types": "Assigned Task Types",
        "group-in-use-cannot-alter-or-delete": "This group is in use and its name cannot be altered nor it deleted.",
        "group-name": "Group Name",
        "assigned-definitions": "Assigned Definitions",
        "assigned-tasks": "Assigned Tasks",
        "restore-group-definitions-warning": "This group contains definitions that are assigned to other groups and will be removed from this group if restored.",
        "the-definitions-are": "The definitions are: ",
        "do-you-want-to-continue": "Do you want to continue?"
    },
    "actuals-definitions": {
        "custom-value-set": "Custom Value Set",
        "decimal-places": "Decimal Places",
        "field-type": "Field Type",
        formula: "Formula",
        metric: "Metric",
        summable: "Summable",
        "value-set": "Value Set",
        "actuals-definitions": "Actuals Definitions",
        "formula-hint": "Eg. [Drill Length] * [Count] + 15",
        "custom-value-set-hint": "Pipe delimited list of values (eg. OptionA|OptionB|OptionC)",
        "value-set-data-type-mismatch": "Value set must match with selected data type",
        "archived-definitions": "Archived Definitions",
        "assigned-definition-groups": "Assigned Definition Groups",
        "production-rate-type": "Production Rate Type",
        "only-numeric-types-may-target-a-production-rate": "Only numeric types may target a production rate",
        "pick-a-driving-production-class": "Pick a driving production class: Drilling, Charging, or Bogging (Remote and Conventional).",
        "definition-assigned-to-mismatched-tasks": "This definition is assigned to tasks (via the Assigned Definition Groups) that don't match the selected production rate type. Please ensure you're happy with this selection.",
        "definition-in-use-cannot-alter": "This definition is in use and cannot be altered or deleted. It may still be archived or restored.",
        "definition-name": "Definition Name",
        "assigned-groups": "Assigned Groups",
        "weight-t": "Weight (t)",
        "weight-kg": "Weight (kg)"
    },
    "ad-hoc-task-editor": {
        "remove-name": "Remove {name}",
        "overridden-location-name": "Overridden Location Name",
        "task-category": "Task Category",
        "task-type": "Task Type",
        "override-task-name": "Override Task Name",
        "start-at": "Start At",
        "duration-minutes": "Duration (minutes)",
        "effort-minutes": "Effort (minutes)",
        priority: "Priority",
        consumables: "Consumables",
        "start-chainage-m": "Start Chainage (m)",
        "end-chainage-m": "End Chainage (m)",
        "edit-task": "Edit Task",
        "add-task": "Add Task"
    },
    "add-cycles": {
        "remove-name": "Remove {name}",
        "cycle-type": "Cycle Type",
        select: "Select",
        "cycle-has-no-tasks": "Cycle has no tasks",
        "target-term": "Target {term}",
        "add-before": "Add before",
        "add-cycle": "Add Cycle",
        warning: "Warning!",
        "inserting-cycles-warning": "Inserting cycles into the plan may cause later cycles to move"
    },
    "add-cycles-from-shift-dialog": {
        "start-at": "Start At",
        "add-cycle": "Add Cycle",
        "cycle-type": "Cycle Type",
        "cycle-has-no-tasks": "Cycle has no tasks",
        "must-provide-cycle-start-time": "Must provide a cycle start time.",
        "cycle-start-time-must-fall-within-shift": "Cycle start time must fall within shift."
    },
    "add-location": {
        search: "Search",
        "select-all": "Select All",
        select: "Select"
    },
    "add-task-dialog": {
        "ring-is-already-status": "Ring is already {status}",
        "ring-is-status-would-skip": "Ring is {status}. This would skip {skipped}",
        "ring-not-reached-target": "Ring has not reached target for {status} yet.",
        "ring-already-completed-target": "Ring has already completed target quantity for {status}.",
        "duration-minutes": "Duration (minutes)",
        quantity: "Quantity",
        "rate-calculated": "Rate (calculated)",
        "start-at": "Start At",
        standard: "Standard",
        rings: "Rings",
        "add-task": "Add Task",
        "fire-duration-cannot-be-changed": "Fire duration cannot be changed.",
        "task-type": "Task Type",
        "term-task": "{term} Task",
        "manually-add-task": "Manually Add Task",
        "add-task-before": "Add Task Before...",
        "add-task-after": "Add Task After...",
        "must-provide-starting-time-for-task": "Must provide a starting time for task.",
        "task-start-time-must-fall-within-shift": "Task start time must fall within shift.",
        "not-all-rings-are-charged": "Not all rings are charged.",
        "not-all-rings-have-completed-charging": "Not all rings have completed charging.",
        "blast-packet-already-fired": "Blast packet has already been fired.",
        "blast-packet-already-started-bogging": "Blast packet has already started bogging.",
        "blast-packet-not-yet-fired": "Blast packet has not yet fired.",
        "bogging-marked-complete": "Bogging for blast packet has been marked complete.",
        "blast-packet-already-completed-bogging-quantity": "Blast packet has already completed target quantity for bogging."
    },
    "assign-shift-owner": {
        "i-confirm-that-i-have-permission-to-take": "I confirm that I have permission to take ownership of the shift.",
        "select-user": "Select user",
        "handover-meeting-not-complete": "Handover meeting not complete",
        "open-handover-meeting": "Open handover meeting",
        "shift-planner": "Shift Planner",
        "confirm-handover-meeting-not-complete": "I confirm that handover meeting isn't complete.",
        "confirm-user-no-shift-planner-role": "I confirm that the selected user doesn't have Shift Planner role."
    },
    "audit-event-explorer": {
        "date-range": "Date Range",
        "event-type": "Event Type",
        "from-date": "From Date",
        namespace: "Namespace",
        "to-date": "To Date",
        advanced: "Advanced",
        "last-7-days": "Last 7 Days",
        "last-30-days": "Last 30 Days",
        "last-90-days": "Last 90 Days"
    },
    "blast-packet-ring-changes-dialog": {
        "duration-minutes": "Duration (minutes)",
        minutes: "Minutes",
        "proceed-without-updating": "Proceed without Updating",
        "changed-drill-length-from": "Changed drill length from",
        "changed-charge-amount-from": "Changed charge amount from",
        "changed-extraction-amount-from": "Changed extraction amount from",
        "no-additional-levels": "No additional levels, add some below"
    },
    board: {
        "shift-date": "Shift {date}",
        "add-name": "Add {name}",
        "some-locations-visible-even-if-filtered": "Some {term} may be visible even if filtered, due to containing dependent tasks",
        "you-are-currently-assigning": "You are currently assigning {equipment}",
        "row-task-update-for": "RowTaskUpdate for {taskId}",
        "add-cycle": "Add Cycle",
        "eos-status": "EOS STATUS",
        "sos-status": "SOS STATUS",
        "shift-board": "Shift Board",
        "exit-by-pressing-ctrl-y-this-mode-disables-certain-constraints-on-board-tasks-use-with-caution": "Exit by pressing \"CTRL+Y\". This mode disables certain constraints on board tasks. USE WITH CAUTION.",
        "add-manual-task": "Add Manual Task",
        "choose-action": "Choose Action",
        "editing-actuals": "You are currently editing Actuals.",
        "highlighting-unresourced-tasks": "Highlighting Unresourced Tasks",
        "location-utilisation": "Location Utilisation",
        "utilisation-priority-1": "Percentage utilisation of priority 1 locations in this shift",
        "utilisation-priority-2": "Percentage utilisation of priority 2 locations in this shift",
        "utilisation-lower-priority": "Percentage utilisation of lower priority locations in this shift",
        "plan-manual-cycle": "Plan Manual Cycle?",
        "manual-cycle-warning-1": "Ordo has been designed to develop a shift plan from a pre-existing weekly plan.",
        "manual-cycle-warning-2": "The requirement to add a manual cycle indicates a weekly plan has not been developed.",
        "manual-cycle-warning-3": "It is preferred to add cycles into the weekly board.",
        "manual-cycle": "Manual Cycle",
        "promoting-fire-task-to-stope": "Promoting fire task to stope.",
        "could-not-find-did-not-fire-task-type": "Could not find did not fire task type",
        "filtering-locations-warning": "You are filtering locations without activity and may not see the new location.",
        "actuals-saved": "Actuals Saved",
        "update-task-error-reloading": "Unexpected error occurred updating task. Reloading shift details from server.",
        "update-task-error-baseline": "Unexpected error occurred updating task. All changes made offline will be saved as a baseline.",
        "update-task-error": "Unexpected error occurred updating task",
        unavailable: "Unavailable",
        "manage-conflict": "Manage Conflict"
    },
    "child-location-editor": {
        "display-order": "Display Order",
        "is-drawpoint": "Is Drawpoint",
        level: "Level",
        "must-not-match-existing-display-order-in-stope": "Must not match existing display order in stope.",
        "location-must-be-in-format": "Location must be in the format '{format}'"
    },
    "communications-configuration": {
        "must-be-or-less-characters": "Must be {num} or less characters",
        department: "Department",
        description: "Description",
        "icon-colour": "Icon Colour",
        type: "Type",
        "week-or-shift": "Week or Shift?",
        "communications-configuration": "Communications Configuration",
        "comms-field": "Comms Field",
        "weekly-comms-fields": "Weekly Comms Fields",
        "shift-comms-fields": "Shift Comms Fields",
        "archived-comms-fields": "Archived Comms Fields",
        persistence: "Persistence",
        order: "Order",
        "fields-reordered": "Fields Reordered"
    },
    "connect-devices": {
        department: "Department",
        "generate-registration-code-now": "Generate Registration Code Now",
        code: "Code",
        "code-expires": "Code Expires",
        "code-refreshed": "Code Refreshed",
        "copied-to-clipboard": "Copied to clipboard",
        "failed-to-copy": "Failed to copy"
    },
    "create-blast-packet-dialog-v2": {
        cycle: "Cycle",
        "duration-minutes": "Duration (minutes)",
        minutes: "Minutes",
        ring: "Ring",
        stope: "Stope",
        "enter-blast-packet-design-details": "Enter blast packet design details",
        "create-term-dialog": "Create {term} Dialog",
        "cycles-must-contain-drill-charge": "Cycles must contain drill and charge tasks and no fire or bogging tasks.",
        "add-term": "Add {term}",
        "no-additional-levels": "No additional {term}, add some below",
        "term-fire-task": "{term} Fire Task",
        "term-bog-task": "{term} Bog Task",
        "tolerance-percent": "Tolerance (%)",
        "at-least-one-term-must-be-added": "At least one {term} must be added."
    },
    "create-user-dialog": {
        email: "Email",
        "initial-password": "Initial Password",
        roles: "Roles",
        select: "Select {term}",
        "add-user": "Add User"
    },
    crews: {
        "select-departments": "Select Departments",
        "cannot-import-no-staff-roles-available": "Cannot import: No staff roles available.",
        roles: "Roles",
        count: "Count"
    },
    cycles: {
        "custom-term": "Custom {term}",
        "archived-term": "Archived {term}",
        abbreviation: "Abbreviation",
        minutes: "Minutes",
        "metres-to-advance": "Metres to Advance",
        "must-be-greater-than-or-equal-to-0": "Must be greater than or equal to 0",
        "metres-to-advance-hint": "How far this cycle will advance a location. Leave blank or set to zero for strip cuts etc.",
        "text-colour": "Text Colour",
        sample: "Sample:",
        "fire-tasks-cannot-change-default-duration": "Fire tasks cannot change their default duration"
    },
    default: {
        "please-select-a-shift-to-begin": "Please select a shift to begin"
    },
    "department-creation-wizard": {
        "cycle-name": "Cycle Name",
        "cycle-name-plural": "Cycle Name (plural)",
        "enforce-cycles-on-development-board": "Enforce Cycles on Development Board?",
        "intended-use": "Intended Use",
        "location-name": "Location Name",
        "location-name-abbreviation": "Location Name (abbreviation)",
        "location-name-plural": "Location Name (plural)",
        "locations-in-resource-planning": "Locations in Resource Planning?",
        "show-on-mine-interaction-board": "Show on Mine Interaction Board?",
        general: "General",
        "use-for-general-mining-activities-including-development-production-and-services": "Use for general mining activities, including Development, Production, and Services.",
        maintenance: "Maintenance",
        "use-for-maintenance-activities": "Use for maintenance activities.",
        note: "Note:",
        config: "Config",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Departments require some specific configuration based on tasks. No tasks exist for this department yet. Configure tasks and then update this department"
    },
    departments: {
        "cut-number-priority-cutoff": "Cut Number Priority Cutoff",
        "cycle-name": "Cycle Name",
        "cycle-name-plural": "Cycle Name (plural)",
        "enforce-cycles-on-development-board": "Enforce Cycles on Development Board?",
        "eos-task": "EoS Task?",
        "intended-use": "Intended Use",
        "location-name": "Location Name",
        "location-name-abbreviation": "Location Name (abbreviation)",
        "location-name-plural": "Location Name (plural)",
        "locations-in-resource-planning": "Locations in Resource Planning?",
        "show-on-mine-interaction-board": "Show on Mine Interaction Board?",
        "sos-tasks": "SoS Tasks?",
        "task-type": "Task Type",
        note: "Note:",
        config: "Config",
        "departments-require-some-specific-configuration-based-on-tasks-no-tasks-exist-for-this-department-yet-configure-tasks-and-then-update-this-department": "Departments require some specific configuration based on tasks. No tasks exist for this department yet. Configure tasks and then update this department",
        "hide-cut-number-chainage-hint": "Hide cut number and chainage information from boards for locations with priority higher than this. Leave blank to show on all locations.",
        "short-code": "Short Code"
    },
    "edit-blast-packet-dialog-v2": {
        "duration-minutes": "Duration (minutes)",
        minutes: "Minutes",
        stope: "Stope",
        "adding-additional-rings-to-a-blast-packet-is-not-supported": "Adding additional rings to a blast packet is not supported.",
        "enter-blast-packet-design-details": "Enter blast packet design details",
        "edit-blast-packet-dialog": "Edit Blast Packet Dialog",
        "no-additional-levels-add-some-below": "No additional levels, add some below",
        "term-bog-task": "{term} Bog Task",
        "tolerance-percent": "Tolerance (%)"
    },
    "edit-equipment-dialog": {
        image: "Image",
        type: "Type",
        "show-conflicts": "Show conflicts",
        "select-departments": "Select {term}",
        "equipment-has-activities-cannot-delete": "This equipment has activities planned or has been assigned to another piece of equipment and cannot be deleted."
    },
    "edit-to-do-action-sheet": {
        description: "Description",
        scope: "Scope",
        title: "Title",
        "creating-task-mine-area-visible": "Creating a task in the Mine Area will make it visible across all departments.",
        "cannot-add-or-edit-tasks-whilst-offline": "Cannot add or edit tasks whilst offline."
    },
    "equipment-downtime-codes": {
        code: "Code",
        order: "Order",
        "downtime-code": "Downtime Code",
        "archived-downtime-codes": "Archived Downtime Codes",
        "codes-reordered": "Codes Reordered"
    },
    "equipment-location-creation-wizard": {
        "select-term-to-plan": "Select {term} to plan for.",
        "ignores-start-of-shift-tasks": "Ignores start-of-shift tasks?",
        "independent-end-of-shift": "Independent end-of-shift?",
        priority: "Priority",
        "an-archived-equipment-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "An archived equipment location exists with this name. Have you considered Restoring it instead of creating a new one?"
    },
    "equipment-roles": {
        "archived-term": "Archived {term}",
        "standard-term": "Standard {term}.",
        "crew-type": "Crew Type",
        "supports-special-display-options": "Supports special display options in print packs, e.g. Service Crew tasks."
    },
    "export-actual-physicals": {
        "from-time": "From Time",
        "export-physicals-range": "Export Physicals Range",
        all: "All",
        "last-90-days": "Last 90 Days",
        custom: "Custom",
        "export-physicals": "Export Physicals",
        "to-time": "To Time",
        "from-time-before-to-time": "From time must be before to time."
    },
    "filtered-select": {
        search: "Search"
    },
    "generate-reporting-months-dialog": {
        "generate-calendar-months": "Generate Calendar Months",
        "target-year": "Target Year",
        "template-year": "Template Year",
        "use-template-year": "Use Template Year",
        generate: "Generate",
        "year-must-be-4-digits": "Year must be 4 digits",
        "add-reporting-months": "Add Reporting Months",
        "template-year-not-same-as-target": "Template year must not be the same as target year."
    },
    "hazard-categories": {
        description: "Description",
        order: "Order",
        "short-name": "Short Name",
        category: "Category",
        "archived-downtime-codes": "Archived Downtime Codes",
        "categories-reordered": "Categories Reordered"
    },
    "hazard-notes-sheet": {
        "hazards-for": "Hazards - {name}",
        "add-new-hazard": "Add new hazard",
        "add-hazard": "Add hazard",
        "cannot-remove-hazards-from-other-departments": "Cannot remove hazards from other departments.",
        "undo-removal": "Undo removal",
        "remove-hazard": "Remove hazard",
        "marked-for-removal": "(Marked for removal)",
        "reported-from-ordo-connect": "Reported from ORDO Connect",
        "new-hazards": "New Hazards",
        "removing-hazards-not-supported-offline": "Removing hazards is not supported when offline. Only new hazards will be added if you save now.",
        "abandon-hazard-changes-message": "You have updated the hazards but must press the \"Save\" button to save your changes. Are you sure you want to discard them?",
        "discard-partial-hazard-message": "You have partially-entered a hazard, but have not added it. Are you sure you want to discard it?"
    },
    "heading-details": {
        priority: "Priority",
        "survey-memo": "Survey Memo",
        "ground-support-profile": "Ground Support Profile",
        "term-plan": "{term} Plan",
        "cannot-edit-whilst-offline": "Cannot edit whilst offline.",
        "must-have-week-planner-role": "Must have week planner role.",
        unavailable: "Unavailable",
        "unavailability-reason": "Unavailability Reason",
        details: "Details",
        "variance-to-plan-comments": "Variance (to plan) Comments",
        "add-note": "Add Note",
        "add-hazard": "Add Hazard",
        "abandon-location-changes-message": "You have updated the location information but must press the \"Save\" button to save your changes. Are you sure you want to discard them?",
        "please-select-image-or-pdf": "Please select an image or PDF file"
    },
    "icon-selector": {
        icon: "Icon",
        search: "Search"
    },
    "import-equipments-availability-plan": {
        from: "From",
        review: "Review",
        "service-type": "Service Type",
        "starts-at": "Starts At",
        "ends-at": "Ends At",
        "import-equipment-availability-plan": "Import Equipment Availability Plan",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Existing data found between provided date range will be replaced or removed",
        "existing-data-that-overlap-provided-date-range-below-will-be-affected": "Existing data that overlap provided date range below will be affected",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Imported data that is not between provided date range below will be skipped",
        to: "To:"
    },
    "import-key-physical-targets-dialog": {
        line: "Line {number}",
        "from-date": "From Date",
        "select-month": "Select Month",
        "unknown-target-type": "Unknown Target Type",
        "import-key-physical-targets": "Import Key Physical Targets",
        validate: "Validate",
        "import-file-details": "Import File Details",
        "import-for-term": "Import for {term}",
        "aid-in-importing-download-template": "To aid in importing targets, please download the template.",
        "each-line-single-target": "Each line in the import file corresponds to a single target.",
        "detail-shift": ": The shift number for the target.",
        date: "Date",
        "detail-date": ": The date of the target in format YYYY-MM-DD.",
        target: "Target",
        "detail-target": ": The value of the target.",
        "target-type": "Target Type",
        "detail-target-type": ": The type of target (e.g. Metres Advanced, Fires). For custom target types use the name set in admin.",
        "import-for-month": "Import for Month",
        "year-not-found": "Year not found in reporting years. Either generate it here or manually create it.",
        "generate-calendar-year": "Generate Calendar Year",
        "copy-previous-year": "Copy Previous Year",
        "import-issues-resolve": "There are one or more issues with your import. Please resolve before continuing",
        "target-type-label": "Target Type:",
        "target-shift-label": "Target Shift:",
        "target-date-label": "Target Date:",
        "target-value-label": "Target Value:",
        "import-may-have-issues": "There may have been issues with your import",
        "unknown-error": "Unknown Error"
    },
    "import-staff-availability-plan": {
        from: "From",
        review: "Review",
        type: "Type",
        "import-staff-availability-plan": "Import Staff Availability Plan",
        "existing-data-found-between-provided-date-range-will-be-replaced-or-removed": "Existing data found between provided date range will be replaced or removed",
        "imported-data-that-is-not-between-provided-date-range-below-will-be-skipped": "Imported data that is not between provided date range below will be skipped",
        "import-leave-records": "Import Leave Records",
        "import-overtime-records": "Import Overtime Records",
        "error-importing-plan": "There was an error importing your staff availability plan",
        "plan-saved-successfully": "Staff availability plan saved successfully"
    },
    "inspection-categories": {
        description: "Description",
        order: "Order",
        "short-name": "Short Name",
        "show-most-recent": "Show Most Recent",
        category: "Category",
        "archived-categories": "Archived Categories",
        "categories-reordered": "Categories Reordered"
    },
    "levelled-resources": {
        "resource-under-utilisation": "Resource Under-Utilisation (%)",
        "levelled-resources": "Levelled Resources",
        "must-be-less-than-resource-level-target": "Must be less than Resource Level Target.",
        "archived-resources": "Archived Resources",
        "utilisation-under-flagged": "Utilisation percentages under this will be flagged.",
        "resource-level-target": "Resource Level Target (%)",
        "must-be-greater-than-resource-under-utilisation": "Must be greater than Resource Under-Utilisation.",
        "utilisation-over-flagged": "Utilisation percentages over this will be flagged.",
        "tooltime-minutes": "Tooltime (minutes)",
        "minutes-per-shift-explanation": "Minutes per shift a staff member in this resource is expected to be able to work.",
        "suggest-assignments": "Suggest Assignments",
        "assigned-task-types": "Assigned Task Types",
        "assigned-staff-roles": "Assigned Staff Roles",
        "resources-reordered": "Resources Reordered"
    },
    "location-commentary-sheet": {
        "notes-for": "Notes - {title}",
        "show-previous-notes": "Show {count} previous {noteWord}",
        comment: "Comment",
        "save-note": "Save note",
        "discard-changes": "Discard changes",
        "no-notes": "No notes",
        "cannot-add-or-alter-notes-if-offline": "Cannot add or alter notes if offline",
        "edit-notes": "Edit notes",
        "add-note": "Add note",
        "no-history": "No history"
    },
    "location-creation-wizard": {
        "default-cycle": "Default Cycle",
        "ignores-start-of-shift-tasks": "Ignores start-of-shift tasks?",
        "independent-end-of-shift": "Independent end-of-shift?",
        "parent-location": "Parent Location",
        priority: "Priority",
        "start-cut-number": "Start Cut Number",
        status: "Status",
        development: "Development",
        "use-for-development-work": "Use for development work.",
        "ad-hoc": "Ad-Hoc",
        "use-for-ad-hoc-operations-like-services": "Use for ad-hoc operations like services.",
        stoping: "Stoping",
        "use-for-all-stopes": "Use for all stopes.",
        "stoping-subheading": "Stoping - Subheading",
        "use-for-stope-children": "Use for stope children.",
        "sub-level-caving": "Sub-Level Caving",
        "use-for-sub-level-caving": "Use for sub-level caving.",
        "an-archived-location-exists-with-this-name-have-you-considered-restoring-it-instead-of-creating-a-new-one": "An archived location exists with this name. Have you considered Restoring it instead of creating a new one?",
        "bogging-horizon": "Bogging Horizon",
        "must-be-positive-integer": "Must be a positive integer"
    },
    "location-tracker": {
        "show-completed-term": "Show Completed {term}",
        "could-not-find-tarp": "Could not find TARP with id {id}",
        "material-destination": "Material Destination",
        "material-type": "Material Type",
        stockpile: "Stockpile",
        "stockpile-status": "Stockpile Status",
        completed: "completed",
        archived: "Archived",
        "tracker-board": "Tracker Board",
        "location-status": "Location Status"
    },
    locations: {
        "allows-planning-against-equipment": "Allows planning tasks against {equipment} instead of a {location}.",
        "standard-term": "Standard {term}.",
        "add-child-term": "Add a child {term}.",
        "archived-term": "Archived {term}",
        "child-term-saved": "Child {term} Saved",
        "cycle-type": "Cycle Type",
        "default-cycle": "Default Cycle",
        "ignores-start-of-shift-tasks": "Ignores start-of-shift tasks?",
        "independent-end-of-shift": "Independent end-of-shift?",
        level: "Level",
        "mining-method": "Mining Method",
        priority: "Priority",
        "start-cut-number": "Start Cut Number",
        status: "Status",
        "cannot-import-no-reduced-levels-available-for-this-mine-area": "Cannot import: No reduced levels available for this mine area.",
        "this-location-has-activities-planned-and-cannot-be-deleted": "This location has activities planned and cannot be deleted.",
        "must-be-a-positive-integer": "Must be a positive integer"
    },
    "material-destinations": {
        abbreviation: "Abbreviation"
    },
    "material-types": {
        abbreviation: "Abbreviation"
    },
    "meeting-guide": {
        search: "Search",
        "shift-deployment": "Shift Deployment",
        "shift-handover": "Shift Handover",
        "shift-interactions": "Shift Interactions"
    },
    "mine-areas": {
        "first-day-of-week": "First Day of Week",
        "first-shift-starts-at": "First Shift Starts At",
        "shift-overlap-minutes": "Shift Overlap (minutes)",
        "shift-schedule": "Shift Schedule",
        "shifts-per-day": "Shifts Per Day",
        "start-counting-weeks-from": "Start Counting Weeks From",
        "temperature-scale": "Temperature Scale",
        "shift-timings": "Shift Timings",
        updating: "Updating...",
        "change-temperature-scale": "Change Temperature Scale",
        "time-zone": "TimeZone",
        "shift-1-name": "Shift 1 Name",
        "shift-2-name": "Shift 2 Name",
        "shift-3-name": "Shift 3 Name",
        "shift-4-name": "Shift 4 Name",
        logo: "Logo",
        sending: "Sending...",
        "upload-logo": "Upload Logo",
        "logo-dimensions-hint": "Logos should ideally be 74 pixels high and no more than 250 pixels wide. To be displayed on a white background. PNG Only",
        "location-name-convention": "Location Name Convention",
        "bad-format": "Bad format",
        "location-convention-hint": "A = letter, N = digit, . = Anything, * = Many. E.g. `A._N*` or `.* A*`",
        "show-help": "Show help",
        "test-location-pattern": "Test Location Pattern",
        "enter-location-name-to-test": "Enter a location name to test",
        "location-pattern-help": "A = 1 letter         A* = many letters\nN = 1 number         N* = many numbers\n? = 1 letter or num  ?* = many letters or numbers\n. = any 1 character  .* = many characters\n\nOther allowed symbols: - _ / and spaces\ne.g. `A._D*` matches H2_123 and HA_444",
        "hide-help": "Hide help",
        configuration: "Configuration",
        "shift-overlap-mins": "Shift Overlap (mins)",
        "location-names": "Location Names",
        "temperature-scale-updated": "Temperature Scale Updated",
        "failed-to-update-temperature-scale": "Failed to update temperature scale",
        "please-select-image-or-pdf-file": "Please select an image or PDF file"
    },
    "move-rings-from-blast-packet-dialog": {
        "source-extraction": "Source Extraction {unit}",
        "target-extraction": "Target Extraction {unit}",
        "blast-packet": "Blast Packet",
        "rings-to-move": "Rings to Move",
        tolerance: "Tolerance (%)",
        move: "Move",
        "i-acknowledge-that-this-will-leave-the-blast-packet-with-no-rings-deleting-it": "I acknowledge that this will leave the blast packet with no rings, deleting it",
        "move-rings-dialog": "Move Rings Dialog",
        "move-title": "Move {items} from {source}",
    },
    "multiple-filtered-select": {
        search: "Search",
        "select-all": "Select All"
    },
    "pending-sync-warning-dialog": {
        "navigate-with-pending-count": "User attempted to navigate with pending count {count} requests queued at {timestamp}",
        "unsaved-changes": "Unsaved Changes",
        "continue-working": "Continue Working",
        "schedule-changes-are-still-being-saved-to-the-server": "Schedule changes are still being saved to the server."
    },
    "planning-drawer-actions": {
        "show-blast-packet-tasks": "Show Blast Packet Tasks"
    },
    "plod-entry": {
        "show-term": "Show {term}",
        "error-deleting-term": "Error deleting {term}",
        "error-populating-actuals-from-shift-plan": "Error populating actuals from shift plan: {error}",
        "error-marking-reportable": "Error marking actuals as ready for reporting: {error}",
        "error-marking-not-reportable": "Error marking actuals as not ready for reporting: {error}",
        "error-copying-task-times": "Error copying task times from shift plan: {error}",
        "error-loading-operator-completion": "Error loading operator completion information: {error}",
        "error-loading-rejected-tasks": "Error loading rejected tasks: {error}",
        equipment: "Equipment",
        formula: "Formula",
        plods: "Plods",
        duplicates: "Duplicates",
        "sync-times": "Sync Times",
        complete: "% Complete",
        "task-type": "Task Type",
        operator: "Operator",
        "show-delays": "Show Delays",
        "view-operator-plod-completion-information": "View operator plod completion information.",
        "view-potential-duplicates": "View potential duplicates.",
        "pull-start-and-end-times": "Pull start and end times for entries from the shift plan.",
        "add-plod-entry": "Add Plod Entry",
        "undo-completion": "Undo Completion",
        "no-actuals-data-found": "No actuals data found matching this shift and filter criteria.",
        "populate-data-for-shift": "Populate Data For Shift",
        "sort-by-up-to-3-columns": "Sort by up to 3 columns",
        column: "Column",
        direction: "Direction",
        "add-level": "Add level",
        apply: "Apply",
        "task-type-column": "Task (Type)",
        "cut-number": "Cut #",
        "start-chainage-m": "Start Chainage (m)",
        "end-chainage-m": "End Chainage (m)",
        "start-time": "Start Time",
        "end-time": "End Time",
        "percentage-of-task-completed": "Percentage of task completed during this shift.",
        ignore: "Ignore",
        "row-will-not-save-until-task-type": "Row will not save until Task Type is selected.",
        "represents-actuals-same-piece-of-work": "Represents actuals all associated with the same piece of work.",
        "reported-from-ordo-connect": "Reported from ORDO Connect.",
        "add-plod-entry-for-piece-of-work": "Add a plod entry for this piece of work.",
        "display-name": "Display Name",
        "enter-comments-here": "Enter comments here...",
        "ignore-row-for-reporting": "Ignore this row for reporting (use for entering duplicate data).",
        totals: "Totals",
        "rejected-tasks": "Rejected Tasks",
        "plod-completion": "Plod Completion",
        "viewing-potential-duplicates-read-only": "Viewing Potential Duplicates - Read Only",
        "undo-deletion": "Undo Deletion",
        "actuals-populated-from-shift-plan": "Actuals populated from shift plan",
        "error-processing-formula": "Error processing formula: ",
        "please-fix-validation-errors": "Please fix validation errors before saving.",
        "cancel-reportability": "Cancel Reportability",
        "confirm-mark-not-ready": "Are you sure you want to mark these plods as not ready for reporting?",
        "mark-reportable": "Mark Reportable",
        "confirm-mark-ready": "Are you sure you want to mark these plods are ready for reporting?",
        "changes-still-possible": "You will still be able to make changes after doing so.",
        "marked-reportable": "Marked reportable",
        "marked-not-reportable": "Marked not reportable",
        "cannot-enter-both-cut-and-chainage": "Cannot enter both Cut # and chainage values. Please use either Cut # or Start/End Chainage.",
        "both-chainage-together": "Both Start Chainage and End Chainage must be entered together, or not at all.",
        "end-chainage-greater-than-start": "End Chainage must be greater than Start Chainage.",
        "task-times-copied": "Task times copied from shift plan",
        "copy-task-times": "Copy Task Times",
        "confirm-copy-task-times": "Are you sure you want to copy task times from the shift plan?"
    },
    "production-front-locations-dialog": {
        search: "Search",
        select: "Select",
        "select-all": "Select All",
        "replace-existing-locations": "Replace Existing {term}"
    },
    "production-front-overlays-dialog": {
        "rotation-degrees": "Rotation (degrees)",
        scale: "Scale",
        "x-offset": "X Offset",
        "y-offset": "Y Offset",
        overlays: "Overlays",
        "overlay-saved": "Overlay Saved"
    },
    "production-fronts": {
        "charge-sleep-expiry-days": "Charge Sleep Expiry (days)",
        department: "Department",
        "drill-charge-rule-distance": "Drill Charge Rule Distance",
        "inter-level-drilling-rule-distance": "Inter-Level Drilling Rule Distance",
        "intra-level-drilling-rule-distance": "Intra-Level Drilling Rule Distance",
        "maximum-lag-distance": "Maximum Lag Distance",
        "maximum-lead-distance": "Maximum Lead Distance",
        "maximum-tonnes-bogged": "Maximum Tonnes Bogged",
        "drill-charge-inter-level-rule": "Drill/Charge Inter-Level Rule",
        "drill-intra-level-rule": "Drill Intra-Level Rule",
        "drill-intralevel-rule": "Drill IntraLevel Rule",
        "charge-sleep-expiry-rule": "Charge Sleep Expiry Rule",
        "drawpoint-tonnes-bogged": "Drawpoint Tonnes Bogged",
        "drawpoint-lead-lag-ring-distances": "Drawpoint Lead-Lag Ring Distances",
        "import-coordinates": "Import Coordinates",
        "cannot-import-no-department-or-front": "Cannot import diagram information when no {term0} or {term1} is selected"
    },
    "property-definition-dialog": {
        "new-value": "new value {number}",
        "display-order": "Display Order",
        type: "Type",
        value: "value",
        "accepted-values": "Accepted Values",
        "property-definition": "Property Definition"
    },
    reporting: {
        department: "Department",
        description: "Description",
        "equipment-role": "Equipment Role",
        label: "Label",
        "last-incident-date": "Last Incident Date",
        "linked-actuals-definitions": "Linked Actuals Definitions",
        metric: "Metric",
        "sub-category-name": "Sub-Category Name",
        value: "Value",
        reporting: "Reporting",
        "physical-target-type": "Physical Target Type",
        "tracked-event-type": "Tracked Event Type",
        "sub-categories": "Sub-Categories",
        "tracked-count-type": "Tracked Count Type",
        "tracked-days-since-last-incident-type": "Tracked Days Since Last Incident Type",
        "select-an-equipment-role-for-the-department-daily-report-configuration-this-role-will-be-used-for-blast-info-first-work": "Select an equipment role for the department daily report configuration. This role will be used for blast info first work.",
        "report-headers": "Report Headers",
        "equipment-role-and-headers": "Equipment Role and Headers",
        "import-reporting-calendar": "Import Reporting Calendar",
        "export-reporting-calendar": "Export Reporting Calendar",
        "warning-this-target-type-may-not-function-correctly-without-at-least-one-actuals-definition": "Warning: This target type may not function correctly without at least one actuals definition.",
        "as-this-is-a-system-defined-target-type-it-is-not-possible-to-associate-this-manually-to-actuals": "As this is a system-defined target type, it is not possible to associate this manually to actuals.",
        "this-physical-target-type-is-in-use-and-cannot-be-deleted": "This physical target type is in use and cannot be deleted.",
        "this-physical-target-type-is-system-defined-and-cannot-be-deleted": "This physical target type is system-defined and cannot be deleted.",
        "this-count-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "This count type is archived. You can restore it using the restore button in the list.",
        "this-incident-type-is-archived-you-can-restore-it-using-the-restore-button-in-the-list": "This incident type is archived. You can restore it using the restore button in the list.",
        "the-last-incident-date-can-only-be-set-when-creating-the-type-you-can-update-it-in-the-data-table-after-creation": "The Last Incident Date can only be set when creating the type. You can update it in the data table after creation.",
        "configure-report-equipment-and-headers": "Configure Report Equipment and Headers",
        "reporting-calendar": "Reporting Calendar",
        "physical-target-types": "Physical Target Types",
        "import-key-physical-targets": "Import Key Physical Targets",
        "system-defined": "System-defined",
        "tracked-event-types": "Tracked Event Types",
        "tracked-count-types": "Tracked Count Types",
        "tracked-days-since-last-incident-types": "Tracked Days Since Last Incident Types",
        "no-sub-categories-defined": "No sub-categories defined. Click \"Add\" to create sub-categories.",
        "event-type-archived-hint": "This event type is archived. You can restore it using the restore button in the list.",
        "add-report-header": "Add Report Header",
        "cannot-have-more-than-2-headers": "Cannot have more than 2 headers",
        "weekly-target": "Weekly Target",
        "daily-target": "Daily Target",
        "weight-t": "Weight (t)",
        "weight-kg": "Weight (kg)",
        "invalid-sub-categories": "Invalid Sub-Categories",
        "all-sub-categories-must-have-a-name": "All sub-categories must have a name. Please provide names for all sub-categories or remove the empty ones.",
        "archive-event-type": "Archive Event Type",
        "confirm-archive-event-type": "Are you sure you want to archive this event type?",
        "restore-event-type": "Restore Event Type",
        "confirm-restore-event-type": "Are you sure you want to restore this event type?",
        "archive-count-type": "Archive Count Type",
        "confirm-archive-count-type": "Are you sure you want to archive this count type?",
        "restore-count-type": "Restore Count Type",
        "confirm-restore-count-type": "Are you sure you want to restore this count type?",
        "archive-incident-type": "Archive Incident Type",
        "confirm-archive-incident-type": "Are you sure you want to archive this incident type?",
        "restore-incident-type": "Restore Incident Type",
        "confirm-restore-incident-type": "Are you sure you want to restore this incident type?"
    },
    "resolve-conflict-dialog": {
        comments: "Comments",
        resolved: "Resolved",
        "jump-to-department": "Jump to Department:"
    },
    resources: {
        "primary-equipment-utilisation": "Percentage utilisation of primary {term} in this shift",
        "secondary-equipment-utilisation": "Percentage utilisation of secondary {term} in this shift",
        "support-equipment-utilisation": "Percentage utilisation of support {term} in this shift",
        "task-not-found": "Task not found for location {location} and task {task}",
        "show-unused": "Show Unused",
        button: {
            "add-crew-role": "Add Crew Role",
            "copy-previous": "Copy Previous",
            "clear-staff": "Clear Staff",
            "unplanned-leave": "Unplanned Leave"
        },
        heading: {
            "assigned-resources": "Assigned Resources",
            "assigned-roles": "Assigned Roles",
            "availability-for": "Availability For {name}",
            "comments-for": "Comments for {name}",
            crews: "Crews",
            "primary-equipment": "Primary Equipment",
            resources: "Resources",
            "secondary-equipment": "Secondary Equipment",
            "support-equipment": "Support Equipment",
            "clear-staff-confirm-prompt": "Clear Staff",
            "add-crew-member": "Add Crew Member",
            "add-crew-role": "Add Crew Role"
        },
        label: {
            "current-location": "Current location",
            "no-tasks": "No Tasks",
            unassigned: "Unassigned",
            "equipment-filtered": "Equipment not visible due to applied filters"
        },
        message: {
            "no-crew-selected": "No crew selected",
            "clear-staff-confirmation": "Cleared all staff assignments.",
            "clear-staff-confirm-prompt": "Are you sure you want to clear all staff assignments?",
            "no-secondary-equipment-assigned": "No Secondary Equipment Assigned",
            "nothing-to-copy": "Nothing to copy - No previous shift found for this department with the same crews selected: {crewNames}",
            "unplanned-leave-confirm": "Confirm Unplanned Leave for Shift",
            "copy-previous": "Allocations copied from previous shift"
        },
        "hide-unavailable-term": "Hide Unavailable {term}",
        "copy-previous-allocations": "Copy Previous Allocations",
        "copy-previous-shift-allocations": "Copy Previous Shift Allocations?",
        yes: "Yes",
        "primary-term": "Primary {term}",
        "secondary-term": "Secondary {term}",
        "support-term": "Support {term}",
        "changing-crews-will-clear-assigned-roles": "Changing crews will clear assigned roles",
        "resource-utilisation": "Resource Utilisation",
        "percentage-utilisation-of-crew-members": "Percentage utilisation of crew-members in this shift",
        "staff-member-no-levelled-resource": "Staff member does not have a levelled resource assigned. Assign directly to tasks instead.",
        "staff-member-no-matching-tasks": "Staff member does not match any tasks by levelled resource. Assign directly to tasks instead."
    },
    "ring-design-generation-dialog": {
        "display-order-in-use": "Display order {displayOrder} is already in use. Using it will insert this ring at that position.",
        "charge-distance": "Charge Distance",
        "drill-distance": "Drill Distance",
        "extraction-amount": "Extraction Amount",
        "hole-name": "Hole Name",
        "ring-order": "Ring Order",
        "select-number-of-holes": "Select Number of Holes",
        "select-ring-template": "Select Ring Template",
        generate: "Generate",
        reset: "Reset",
        "add-hole": "Add Hole",
        "must-have-at-least-one-hole": "Must have at least one hole"
    },
    sandpit: {
        "department-name": "Department: {name}",
        "setup-week-plan-with-adjacent": "Setup the departments week plan for this week {asAt}, along with the previous and next weeks plans ",
        "setup-week-plan": "Setup the departments week plan for this week {asAt} ",
        "blast-packets": "Blast Packets",
        "comms-fields": "Comms Fields",
        crews: "Crews",
        cycles: "Cycles",
        equipment: "Equipment",
        "last-week-plan-template": "Last Week Plan Template",
        levels: "Levels",
        locations: "Locations",
        "next-week-plan-template": "Next Week Plan Template",
        overlays: "Overlays",
        rings: "Rings",
        "scenario-directory": "Scenario Directory",
        "select-all-files-for-specific-scenarios": "Select all files for specific scenarios",
        "select-all-visualisation-overlay": "Select all visualisation overlay",
        tarps: "TARPs",
        "task-types": "Task Types",
        "visualisation-co-ordinates": "Visualisation Co-ordinates",
        "week-plan-template": "Week Plan Template",
        "manage-the-sandpit-mine-area": "Manage the sandpit mine area",
        "long-running-action": "Long Running Action",
        "import-all": "Import All",
        "populate-sandpit-data": "Populate Sandpit Data",
        "setup-the-sandpit-mine-area-with-data-from-import-files": "Setup the sandpit mine area with data from import files",
        "manage-department-data": "Manage Department Data",
        "setup-the-sandpit-department-with-department-specific-data": "Setup the sandpit department with department specific data",
        "manage-week-plan": "Manage Week Plan",
        "manage-visualisation": "Manage Visualisation",
        "setup-the-departments-visualisation": "Setup the departments visualisation",
        "the-import-will-create-development-and-production-departments-this-can-take-approximately-15-minutes-to-complete": "- The import will create development and production departments. This can take approximately 15 minutes to complete.",
        "this-action-could-take-some-time-to-complete-it-is-creating-3-week-plans": "- This action could take some time to complete. It is creating 3 week plans",
        "creating-rings-and-blast-packets-can-take-some-time-to-complete": "- Creating rings and blast packets can take some time to complete",
        "creating-three-sub-level-caving-week-plans-can-take-approximately-5-10-minutes-to-complete": "- Creating three Sub Level Caving week plans can take approximately 5-10 minutes to complete.",
        "sandpit-loader": "Sandpit Loader"
    },
    "shift-board-row": {
        "hide-unavailability-sign": "Hide unavailability sign",
        "show-unavailability-sign": "Show unavailability sign",
        unavailable: "Unavailable"
    },
    "shift-loader": {
        "shift-loader-name": "Shift Loader: {name}",
        "planning-for-this-week-has-not-started-create": "Planning for this week has not started. Create a weekly plan before planning this shift",
        "shift-loader": "Shift Loader"
    },
    "shift-printer": {
        source: "Source",
        "print-shift-packs": "Print Shift Packs",
        "maintenance-shift-pack": "Maintenance Shift Pack",
        "shift-pack": "Shift Pack",
        "compressed-shift-pack": "Compressed Shift Pack",
        "term-pack": "{term} Pack",
        "term-details": "{term} Details",
        "download-csv": "Download CSV",
        "training-shift-pack": "Training Shift Pack",
        "blank-shift-plan": "Blank Shift Plan",
        "current-plan": "Current Plan",
        "publish-shift": "Publish Shift?",
        "would-you-like-to-publish-baseline": "Would you like to publish this shift as a baseline?",
        "failed-to-publish-shift": "Failed to publish shift.",
        "published-shift-as-baseline": "Published shift as baseline."
    },
    "shift-reports": {
        "this-shift-published-baseline": "This shift published baseline",
        "baseline-for-previous-shift-not-found": "Baseline For Previous Shift Not Found",
        "compare-last-24hr-actuals-to-published-plan": "Compare Last 24Hr Actuals to Published Plan",
        "shift-variance-report": "Shift Variance Report",
        "previous-shift-published-baseline": "Previous shift published baseline",
        "variance-report": "Variance Report",
        "current-plan": "Current Plan"
    },
    "shift-selector": {
        "week-commencing": "Week {weekNumber} w/c {date} ",
        date: "Date",
        department: "Department",
        "mine-area": "Mine Area",
        "select-shift": "Select Shift...",
        "select-shift-title": "Select Shift",
        select: "Select",
        "week-of": "Week of",
        "mine-interactions-board": "Mine Interactions Board"
    },
    "shift-task-actions": {
        "add-task-after": "Add Task After",
        "add-task-before": "Add Task Before",
        "delete-task": "Delete Task",
        "edit-quantity": "Edit Quantity",
        "edit-task": "Edit Task",
        "send-to-next-shift": "Send to next shift",
        "show-planned-targets": "Show Planned Targets",
        split: "Split",
        "switch-bogging-type": "Switch Bogging Type",
        "show-usage": "Show {term} Usage"
    },
    "split-task-dialog": {
        "delay-duration": "Delay Duration",
        "delay-type": "Delay Type",
        "split-a-task-and-insert-a-delay": "Split a task and insert a delay",
        "split-task": "Split Task",
        "can-t-split-tasks-which-are-shorter-than-45-minutes": "Can't split tasks which are shorter than 45 minutes."
    },
    "staff-roles": {
        "archived-term": "Archived {term}",
        supervisor: "Supervisor?"
    },
    "standard-dialog": {
        "could-not-load-the-required-data-for-this": "Could not load the required data for this dialog"
    },
    stockpiles: {
        abbreviation: "Abbreviation",
        status: "Status"
    },
    "subscribers-dialog": {
        "add-new-subscriber": "Add new subscriber",
        events: "Events",
        "notification-subscribers": "Notification Subscribers",
        "select-all": "Select All",
        "weekly-board": "Weekly Board",
        "must-not-match-existing-email": "Must not match existing email.",
        "confirm-abandon-partially-added": "You have partially added a new subscriber and must press the \"Add\" button to complete the process. Are you sure you want to abandon the changes?",
        "confirm-abandon-partially-updated": "You have partially updated a subscriber and must press the \"Update\" button to complete the process. Are you sure you want to abandon the changes?"
    },
    "supervisor-actuals-tab": {
        "add-term-variance": "Add {term} Variance",
        "heading-not-found": "Heading with planned location id {id} not found.",
        comment: "Comment",
        location: "Location",
        comments: "Comments",
        "variance-to-plan": "Variance to Plan",
        "add-variance-to-plan": "Add Variance to Plan",
        "remove-variance-reason": "Remove variance reason"
    },
    "supervisor-safety-and-incidents-tab": {
        location: "Location",
        safety: "Safety",
        "add-safety-incident": "Add Safety Incident",
        "add-safety-observation": "Add Safety Observation",
        "add-jsea": "Add JSEA",
        "add-condition-report": "Add Condition Report",
        incidents: "Incidents",
        "add-condition-monitoring": "Add Condition Monitoring",
        "add-job-safety-environmental-analysis": "Add Job Safety Environmental Analysis",
        "remove-incident": "Remove Incident",
        observations: "Observations",
        "remove-observation": "Remove Observation",
        "remove-jsea": "Remove JSEA",
        "condition-monitoring": "Condition Monitoring",
        "thermal-work-limit": "Thermal Work Limit",
        "wet-bulb-temp": "Wet Bulb Temp",
        "dry-bulb-temp": "Dry Bulb Temp",
        activity: "Activity",
        "remove-condition-report": "Remove condition report",
        time: "Time",
        "wet-bulb-temperature": "Wet Bulb Temperature",
        "dry-bulb-temperature": "Dry Bulb Temperature"
    },
    "task-categories": {
        "mine-area": "Mine Area"
    },
    "task-group-actions": {
        accept: "Accept",
        "edit-task": "Edit Task",
        "show-blast-packet-tasks": "Show Blast Packet Tasks"
    },
    "task-suggestion": {
        "duration-min": "Duration: {minutes} min ",
        "end-date": "End Date",
        "end-time": "End Time",
        "planned-quantity": "Planned Quantity",
        "start-date": "Start Date",
        "start-time": "Start Time",
        "add-task": "Add Task",
        "duration-must-be-greater-than-0": "Duration must be greater than 0"
    },
    tasks: {
        "system-term": "System {term}",
        "custom-term": "Custom {term}",
        "archived-term": "Archived {term}",
        abbreviation: "Abbreviation",
        "category-type": "Category Type",
        department: "Department",
        "name-future-tense": "Name (Future Tense)",
        "name-when-in-progress": "Name when in Progress",
        "system-task-class": "System Task Class",
        "naming-tasks": "Naming Tasks",
        "future-tense-and-in-progress-are-the-names-used-to-refer-to-this-task-in-the-future-or-in-progress-e-g-for-bog-the-future-tense-would-be-to-bog-and-in-progress-would-be-bogging": "- 'future tense' and 'in progress' are the names used to refer to this task in the future or in progress. E.g. for 'Bog' the future tense would be 'To Bog' and in progress would be 'Bogging'",
        "this-a-system-setting-and-changing-this-will-have-system-wide-effects-changing-task-class-can-change-system-behaviour-this-is-an-administration-action-only": "- This a system setting and changing this will have system wide effects. Changing task class can change system behaviour. This is an administration action only.",
        "some-task-classes-removed": "Some task classes have been removed from the list, as they are already in use.",
        "is-delay": "Is Delay?",
        "allocate-actuals-to-next-cut": "Allocate Actuals to Next Cut?",
        "default-time-mins": "Default time (mins)",
        "delay-type": "Delay Type",
        metric: "Metric",
        "linked-physical": "Linked Physical",
        "task-colour": "Task Colour",
        "text-colour": "Text Colour",
        sample: "Sample:",
        "default-split-delay-type": "Default Split Delay Type",
        "default-time-mins-col": "Default Time (mins)",
        "weight-t": "Weight (t)",
        "weight-kg": "Weight (kg)",
        "error-loading-actuals-definitions": "Error loading actuals definitions:",
        "term-imported": "{term} Imported"
    },
    "tenant-change": {
        "select-org-mine": "Select Org/Mine",
        "select-your-organisation-mine": "Select your Organisation/Mine"
    },
    terms: {
        search: "Search",
        "show-as": "Show As",
        "show-as-plural": "Show As, Plural"
    },
    "trigger-action-response-plans": {
        department: "Department",
        description: "Description",
        "display-order": "Display Order",
        order: "Order",
        "generate-3-status-tarp": "Generate 3-Status TARP",
        "generate-5-status-tarp": "Generate 5-Status TARP",
        "task-colour": "Task Colour"
    },
    "update-location-status-dialog": {
        status: "Status",
        stope: "Stope"
    },
    "update-tarp-status-dialog": {
        status: "Status",
        stope: "Stope",
        loader: "Update TARP Status Dialog",
        "confirm-set-existing-value": "You are setting the status to its existing value. Are you sure?"
    },
    "user-departments-dialog": {
        "select-departments": "Select Departments"
    },
    users: {
        search: "Search",
        "mdi-shield-check": "mdi-shield_check",
        "user-admin": "User Admin",
        "confirm-delete": "Confirm DELETE",
        "confirm-deactivate": "Confirm Deactivate"
    },
    "week-equipment": {
        "start-at": "Start At",
        "weekly-service": "Weekly Service",
        "minor-service": "Minor Service",
        "major-service": "Major Service",
        unserviceable: "Unserviceable",
        "idle-unavailable-this-week": "Idle/Unavailable This Week",
        services: "Services",
        "ends-at": "Ends At",
        "must-be-greater-than-start": "Must be greater than start"
    },
    "week-resourcing": {
        "crew-this-week": "Crew this Week",
        "default-crew": "Default Crew",
        available: "Available",
        "leave-in-week": "Leave in week",
        "overtime-in-week": "Overtime in week",
        "add-staff": "+ Add Staff",
        unavailable: "Unavailable",
        "overtime-available": "Overtime Available",
        leave: "Leave",
        overtime: "Overtime",
        "successfully-assigned-staff-to-crew": "Successfully assigned staff to crew",
        "unable-to-assign-staff-to-crew": "Unable to assign staff to crew",
        "hide-unassigned": "Hide Unassigned",
        "show-unassigned": "Show Unassigned"
    },
    weekly: {
        "add-name": "Add {name}",
        "remove-name": "Remove {name}",
        "no-locations-can-be-removed": "No {term} can be removed",
        "unable-to-find-target-row": "Unable to find target row for {name} ({id})",
        "task-type-not-found": "Task type with id {id} not found.",
        "unknown-action": "Unknown action: {action}",
        "collapse-cycles": "Collapse Cycles",
        "export-adhoc-tasks": "Export AdHoc Tasks",
        "planning-for-this-week-has-not-started": "Planning for this week has not started",
        "import-plan": "Import Plan",
        "export-plan": "Export Plan",
        "copy-allocations-to-right": "Copy {term} allocations to right",
        "export-assignments": "Export {term} Assignments",
        "week-plan": "Week Plan",
        "reset-plan": "Reset Plan",
        "export-week-plan-to-csv": "Export Week Plan to CSV",
        "weekly-board": "Weekly Board",
        "change-shift-summary-row": "Change Shift Summary Row",
        "start-planning": "Start Planning",
        "weekly-board-export": "Weekly Board Export",
        "week-warnings": "Week Warnings",
        "editing-historic-cycles": "You are currently editing historic cycles!",
        "shift-info": "Shift Info",
        "crew-information": "Crew Information",
        "reset-week-plan": "Reset Week Plan",
        "confirm-reset-week-plan": "Are you sure you want to reset the week plan?",
        "reset-week-plan-warning": "Doing so will delete any tasks starting during this week.",
        "promoting-fire-task-to-stope": "Promoting fire task to stope.",
        "filtering-locations-warning": "You are filtering locations without activity and may not see the new location.",
        "failed-export-week-plan": "Failed to export week plan.",
        "delete-name": "Delete {name}",
        "confirm-delete-task": "Are you sure you want to delete this task?",
        "week-targets-generated": "Week Targets Generated"
    },
    "daily-report": {
        "total-count": "Total: {count}",
        "error-loading-daily-report": "Error loading daily report: {error}",
        "error-generating-daily-report": "Error generating daily report: {error}",
        "error-regenerating-daily-report": "Error regenerating daily report: {error}",
        "error-saving-daily-report": "Error saving daily report: {error}",
        "error-marking-approved": "Error marking daily report as approved: {error}",
        "error-marking-not-approved": "Error marking daily report as not approved: {error}",
        "daily-report": "Daily Report",
        "time-of-blast": "Time of Blast",
        "pic-safe": "PIC Safe",
        equip: "Equip.",
        "first-work-time": "First Work Time",
        activity: "Activity",
        location: "Location",
        comments: "Comments",
        "report-approved-for-use": "Report approved for use.",
        "enter-edit-mode": "Enter Edit Mode",
        "save-and-exit": "Save And Exit",
        "cancel-approval": "Cancel Approval",
        approve: "Approve",
        "no-daily-report-found": "No daily report found for this date.",
        "generate-daily-report": "Generate Daily Report",
        "daily-report-cannot-be-created-in-future": "Daily report cannot be created in the future.",
        "locations-needing-re-entry": "Locations Needing Re-entry",
        "refresh-from-data-entry": "Refresh from data entry.",
        "to-alter-this-list": "To alter this list, please go back and change it on the data entry page.",
        "measurement-date": "Measurement Date",
        "to-date": "To Date",
        "hide-subcategories": "Hide subcategories",
        "subcategories-available": "Subcategories available",
        reset: "Reset",
        "row-will-not-save-until-equipment-selected": "Row will not save until Equipment is selected.",
        "remove-first-work-activity": "Remove first work activity.",
        "add-new-first-work-activity": "Add a new first work activity.",
        "add-new-comment": "Add a new comment.",
        remove: "Remove.",
        "daily-report-generated-successfully": "Daily report generated successfully",
        "daily-report-regenerated-successfully": "Daily report regenerated successfully",
        "daily-report-saved-successfully": "Daily report saved successfully",
        "confirm-mark-not-approved": "Are you sure you want to mark this daily report as not approved?",
        "approve-report": "Approve Report",
        "confirm-mark-approved": "Are you sure you want to mark this daily report as approved?",
        "still-able-to-make-changes": "You will still be able to make changes after doing so.",
        "daily-report-approved": "Daily report approved",
        "daily-report-unapproved": "Daily report unapproved"
    },
    "equipment-downtime": {
        equipment: "Equipment",
        "downtime-code": "Downtime Code",
        "duration-minutes": "Duration (minutes)",
        comments: "Comments",
        "add-equipment-downtime": "Add Equipment Downtime",
        "no-data-available-in-the-table": "No data available in the table."
    },
    "key-physical-actuals": {
        "error-populating-actuals-from-shift-plan": "Error populating actuals from shift plan: {error}",
        cut: "Cut #",
        "metres-advanced": "Metres Advanced",
        "start-chainage-m": "Start Chainage (m)",
        "end-chainage-m": "End Chainage (m)",
        "tonnes-fired": "Tonnes Fired",
        "measured-tonnes-fired": "Measured Tonnes Fired",
        "no-key-physicals-data-found": "No key physicals data found.",
        "populate-data-for-shift": "Populate Data For Shift",
        "add-metres-advanced": "Add Metres Advanced",
        "add-tonnes-fired": "Add Tonnes Fired",
        note: "Note:",
        "metres-advanced-readjust-warning": "Changes to metres advanced (adding / updating / deleting) could result in cut numbers and chainage starts being readjusted downstream.",
        "cut-number": "Cut #",
        "start-chainage": "Start Chainage",
        "single-box-metres-advanced": "Single Box Metres Advanced",
        "end-chainage": "End Chainage",
        "planned-metres-tooltip": "The planned metres advanced from the week plan. Enter a value to override.",
        "updated-metres-tooltip": "Updated metres advanced. Remove this value to revert to the week plan value.",
        "averaged-value-tooltip": "Averaged value for this cut according to the most relevant surveyed length.",
        "actuals-populated-from-shift-plan": "Actuals populated from shift plan",
        "delete-cut": "Delete Cut",
        "are-you-sure-delete-cut": "Are you sure you want to delete this Cut? Any actuals associated with this Cut Number will have the association removed."
    },
    "admin-home": {
        administration: "Administration"
    },
    "navigation-drawer": {
        security: "Security",
        sandpit: "Sandpit",
        "clear-local-tenant-cache": "Clear Local Tenant Cache",
        configuration: "Configuration",
        "communications-configuration": "Communications Configuration",
        reporting: "Reporting",
        "local-tenant-information-cleared": "Local tenant information cleared."
    },
    "admin-sandpit-item-name": {
        sp: "(SP)"
    },
    "admin-sandpit-visibility-selector": {
        "sandpit-visibility": "Sandpit Visibility"
    },
    "admin-equipment": {
      "equipment": {
          "charger": "Charger",
          "service-crew": "Service Crew",
          "flatbed-truck": "Flatbed Truck",
          "personnel-carrier": "Personnel Carrier",
          "water-truck": "Water Truck",
          "tanker-truck": "Tanker Truck",
          "explosives-truck": "Explosives Truck",
          "forklift": "Forklift",
          "drill-rig-surface": "Drill Rig (Surface)",
          "crane-franna": "Crane (Franna)",
          "service-truck": "Service Truck",
          "storeperson": "Storeperson",
          "dump-truck-surface": "Dump Truck (Surface)",
          "fuel-truck": "Fuel Truck",
          "crane-mobile": "Crane (Mobile)",
          "digger-backhoe": "Digger (Backhoe)",
          "digger-front-end": "Digger (Front End)",
          "dozer": "Dozer",
          "dragline": "Dragline",
          "prime-mover-tipper-trailer": "Prime Mover Tipper Trailer",
          "electric-rope-shovel": "Electric Rope Shovel",
          "cabolter": "Cabolter",
          "diamond-drill-rig": "Diamond Drill Rig",
          "lHD-loader": "LHD Loader",
          "longhole-drill-rig": "Longhole Drill Rig",
          "refuge-chamber": "Refuge Chamber",
          "scissor-lift": "Scissor Lift",
          "sprayer": "Sprayer",
          "grader": "Grader",
          "charger-uphole": "Charger (Uphole)",
          "compaction-roller": "Compaction Roller",
          "agitator-truck": "Agitator Truck",
          "jumbo-drill-rig": "Jumbo Drill Rig",
          "integrated-toolcarrier": "Integrated Toolcarrier",
          "dump-truck-underground": "Dump Truck (Underground)",
          "light-vehicle-tray": "Light Vehicle (Tray)",
          "light-vehicle-wagon": "Light Vehicle (Wagon)",
          "raisebore-rig": "Raisebore Rig",
          "spotter": "Spotter",
          "plant": "Plant",
          "hydraulic-excavator": "Hydraulic Excavator"
      }
    },
    "shift-schedule-editor": {
        "shift-name": "Shift Name",
        "duration-minutes": "Duration (minutes)",
        "shift-schedule": "Shift Schedule",
        "each-day-must-have-shifts-that-total-exactly-1440-minutes-24-hours": "Each day must have shifts that total exactly 1440 minutes (24 hours).",
        "add-shift": "Add Shift",
        "shift-schedule-saved": "Shift Schedule Saved",
        "failed-to-save-shift-schedule": "Failed to save shift schedule"
    },
    "stope-blast-packets-list": {
        "new-term": "New {term}",
        "delete-term": "Delete {term}",
        "edit-term": "Edit {term}",
        "move-term": "Move {term}",
        loading: "Loading {term}",
        "last-updated": "Last Updated"
    },
    "task-debug": {
        "cycle-id": "Cycle Id",
        "task-id": "Task Id",
        correlation: "Correlation",
        "auto-split": "Auto split",
        "manual-split": "Manual split",
        "different-from-config": "Different from config",
        "is-locked-in-past": "Is locked in past"
    },
    "task-details-badge": {
        cut: "Cut #:",
        quantity: "Quantity:",
        chainage: "Chainage:",
        "not-set": "Not set"
    },
    "captain-board": {
        "shift-interactions-date": "Shift Interactions {date}",
        "split-over-eos": "(split over EoS)",
        legend: "Legend",
        "shift-interactions": "Shift Interactions"
    },
    "interactions-side-drawer": {
        meetings: "Meetings",
        "shift-interactions": "Shift Interactions",
        "filters-and-groups": "Filters and Groups",
        filters: "Filters",
        grouping: "Grouping",
        columns: "Columns",
        groupings: "Groupings",
        conflicts: "Conflicts",
        "interactions-side-drawer": "Interactions Side Drawer",
        "shift-interactions-meeting": "Shift Interactions Meeting"
    },
    "stope-rings-list": {
        "new-term": "New {term}",
        reorder: "Reorder",
        loading: "Loading {term}",
        "total-drill-distance": "Total Drill Distance",
        "total-charge": "Total Charge",
        "extraction-amount": "Extraction Amount",
        "ring-order": "Ring Order",
        "last-updated": "Last Updated"
    },
    "development-tracker-board": {
        "latest-cut": "Latest: {cutNumber}",
        "start-cut": "Start: {cutNumber}",
        "more-info": "more info",
        "calculated-from-latest-chainage": "Calculated from latest chainage, and entered metres advanced.",
        "cut-number": "CUT #",
        "last-survey": "LAST SURVEY",
        "chainage-calc": "CHAINAGE (Calc)"
    },
    "import-blast-packets": {
        validate: "Validate",
        "there-are-one-or-more-issues-with-the-blast-packet-design-please-resolve-before-continuing": "There are one or more issues with the blast packet design. Please resolve before continuing",
        "successfully-imported-blast-packets": "Successfully imported blast packets",
        "there-may-have-been-issues-with-your-import": "There may have been issues with your import"
    },
    "import-location-rings": {
        validate: "Validate",
        "there-are-one-or-more-issues-with-the-ring-design-please-resolve-before-continuing": "There are one or more issues with the ring design. Please resolve before continuing",
        "successfully-import-rings": "Successfully import rings",
        "import-issues": "There may have been issues with your import",
        "ring-order": "Ring Order",
        "hole-name": "Hole Name",
        "drill-distance": "Drill Distance",
        "charge-distance": "Charge Distance"
    },
    "location-tracker-side-drawer": {
        "archived-term": "Archived {term}",
        rings: "Rings",
        "blast-packets": "Blast Packets",
        physicals: "Physicals",
        "column-options": "Column Options",
        information: "Information",
        planning: "Planning",
        "shift-sidedrawer": "Shift Sidedrawer",
        "location-filters": "Location Filters",
        clear: "Clear",
        "show-archived": "Show Archived"
    },
    "slc-tracker-board": {
        "location-ring-assigned-to-blast-packet": "Location ring {name} is assigned to a blast packet.",
        "blast-packet-has-work": "Blast packet {name} has work planned and/or recorded against it.",
        "bogging-priority": "Bogging Priority",
        "ring-duration": "RING DURATION (days since last fire)",
        "avg-ring-tonnes-per-day": "AVG RING TONNES/DAY",
        "current-status": "CURRENT STATUS",
        "based-on-last-entered-actuals-or-fire-task": "Based on last entered actuals or fire task",
        "last-ring-drilled": "LAST RING DRILLED",
        "last-ring-charged": "LAST RING CHARGED",
        "last-ring-fired": "LAST RING FIRED",
        "days-charged": "DAYS CHARGED",
        "next-ring-to-fire": "NEXT RING TO FIRE",
        "recovery-ring-detail": "RECOVERY RING DETAIL",
        "bogged-to-date": "BOGGED TO DATE (t)",
        "still-to-bog": "STILL TO BOG (t)",
        "extraction-target": "EXTRACTION TARGET (t)",
        "delete-location-ring": "Delete Location Ring",
        "checking-status": "Checking status...",
        "are-you-sure-delete-location-ring": "Are you sure you want to delete this location ring?",
        "deleting-may-lead-to-lost-work": "Deleting it may lead to lost work and/or the deletion of the associated blast packet.",
        "confirm-type-name-location-ring": "To confirm you wish to delete it, please type the name of the location ring below.",
        "warning-action-cannot-be-undone": "Warning: This action cannot be undone.",
        "delete-term": "Delete {term}",
        "are-you-sure-delete-blast-packet": "Are you sure you want to delete this blast packet?",
        "confirm-type-name-blast-packet": "To confirm you wish to delete it and any associated work, please type the name of the blast packet below.",
        "failed-to-update-blast-packet": "Failed to update blast packet"
    },
    "stope-levels-list": {
        "stope-term": "Stope {term}",
        "location-has-work-planned": "Location {name} has work planned against it.",
        "add-drawpoint": "Add Drawpoint",
        "delete-location": "Delete Location",
        "checking-status": "Checking status...",
        "are-you-sure-delete-stope-location": "Are you sure you want to delete this stope location?",
        "confirm-type-location-name": "To confirm you wish to delete it and any associated work, please type the name of the location below.",
        "warning-cannot-be-undone": "Warning: This action cannot be undone."
    },
    "stope-tracker-board": {
        "more-info": "more info",
        "bogging-priority": "Bogging Priority",
        "calculated-tonnes-tooltip": "Calculated from latest surveyed tonnes in stope, entered fired tonnes, and entered bogging figures.",
        "tonnes-in-stope": "Tonnes in Stope",
        "avg-tonnes-per-day": "AVG TONNES/DAY",
        "bogged-to-date": "BOGGED TO DATE (t)",
        "survey-tonnes": "SURVEY TONNES",
        "tonnes-avail": "TONNES AVAIL"
    },
    "production-front-viewer": {
        "ring-statuses": "Ring Statuses",
        "remove-from-viewer": "Remove from viewer",
        "add-to-viewer": "Add to viewer",
        "lashing-lashed": "Lashing / Lashed",
        fired: "Fired",
        "charging-charged": "Charging / Charged",
        "drilling-drilled": "Drilling / Drilled",
        "not-drilled": "Not Drilled",
        "ring-names": "Ring Names",
        none: "None",
        highlight: "Highlight",
        all: "All",
        choose: "Choose",
        "front-progress": "Front Progress",
        drilling: "Drilling",
        "hide-all-ring-names": "Hide all {term} names",
        "show-last-drilled-next-to-fire-ring-names": "Show last drilled and next to fire {term} names",
        "show-all-ring-names": "Show all {term} names",
        "planned-work": "Planned Work",
        "work-planned": "Work planned",
        "charge-sleep-expiry": "Charge Sleep Expiry",
        "visible-level": "Visible {term}",
        "show-additional-levels": "Show Additional {term}",
        "planning-view": "Planning View",
        "no-planning-overlay": "No planning overlay",
        "show-rings-to-consider-for-progressing-front": "Show {term} to consider for progressing front",
        "show-valid-rings-to-drill": "Show valid {term} to drill",
        "start-planning": "Start Planning"
    },
    "audit-event-viewer": {
        "failed-to-load-data": "Failed to load data",
        "hide-detail": "Hide Detail",
        "show-detail": "Show Detail",
        "audit-event-viewer": "Audit Event Viewer",
        "no-audit-events": "No audit events",
        "load-more": "Load More"
    },
    "change-conflict": {
        "a-change-has-conflicted-with-another-users-changes": "A change has conflicted with another users changes.",
        "location-name": "Location Name",
        "updated-by": "Updated By",
        "change-conflict": "Change Conflict",
        "refresh-data": "Refresh Data"
    },
    "communications-equipment-task-card": {
        "task-comments": "Task Comments"
    },
    "generate-week-key-physical-targets-dialog": {
        "generate-week-targets": "Generate Week Targets",
        "checking-if-targets-already-exist-for-the-week": "Checking if targets already exist for the week...",
        "targets-already-exist-for-the-week": "Targets already exist for the week.",
        "do-you-want-to-replace-the-existing-targets": "Do you want to replace the existing targets?",
        "generate-targets-for-the-week": "Generate targets for the week?",
        "there-are-currently-no-existing-targets-for-this-week": "There are currently no existing targets for this week.",
        generate: "Generate"
    },
    "main-menu": {
        version: "Version {version}",
        "change-org-mine": "Change Org/Mine",
        administration: "Administration",
        help: "Help",
        "main-menu": "Main Menu",
        logout: "Logout"
    },
    "navigation-menu": {
        "navigation-menu": "Navigation Menu",
        "geomoby-logo": "GeoMoby Logo",
        "shift-board": "Shift Board",
        "data-entry": "Data Entry",
        "resource-chart": "Resource Chart",
        "governance-analytics": "Governance Analytics",
        "daily-analytics": "Daily Analytics",
        "crew-magnet-board": "Crew Magnet Board",
        "equipment-magnet-board": "Equipment Magnet Board",
        "shift-supervisor-report": "Shift Supervisor Report",
        "week-board": "Week Board",
        "slc-tracker-board": "SLC Tracker Board",
        "stope-tracker-board": "Stope Tracker Board",
        "development-tracker-board": "Development Tracker Board",
        "production-front-viewer": "Production Front Viewer",
        "geomoby-mine-map": "GeoMoby Mine Map",
        "reporting-targets": "Reporting Targets",
        "daily-report": "Daily Report",
        "resources": "Resources",
        "communications": "Communications"
    },
    "no-permission-button": {
        "no-permission": "No Permission",
        "insufficient-permission": "insufficient permission to perform this action"
    },
    "print-window": {
        "problems-previewing": "Problems previewing?",
        download: "Download",
        refresh: "Refresh",
        "print-window": "Print Window"
    },
    "shift-owner-menu": {
        "shift-owner": "Shift Owner",
        "publish-shift": "Publish Shift",
        handover: "Handover",
        assign: "Assign",
        "take-ownership": "Take Ownership",
        "publish-shift-as-a-snapshot": "Publish shift as a snapshot",
        "start-handover-meeting": "Start a handover meeting with another user",
        "assign-shift-ownership": "Assign shift ownership to another user",
        "take-shift-ownership": "Take shift ownership",
        "confirm-publish-shift": "Are you sure you want to publish this shift and create a publish baseline",
        "no-shift-owner": "No shift owner"
    },
    "terms-and-conditions": {
        "end-user-license-agreement": "End User License Agreement",
        "please-read-through-and-accept-the-end-user-license-agreement-to-continue": "Please read through and accept the end user license agreement to continue.",
        "cancel-and-logout": "Cancel and Logout",
        agree: "Agree",
        "accepted-terms-and-conditions": "Accepted Terms and Conditions"
    },
    "to-do-actions-menu": {
        "add-task": "Add Task",
        "no-tasks": "No Tasks",
        "cannot-add-tasks-whilst-offline": "Cannot add tasks whilst offline."
    },
    "version-check": {
        "your-version-of-ordo-is-out-of-date-please-reload-now": "Your version of Ordo is out of date. Please reload now.",
        "new-version": "New version:",
        "your-version": ", your version:",
        "ordo-updated": "Ordo Updated",
        reload: "Reload"
    },
    priority: {
        priority: "Priority",
        completion: "Completion",
        "priority-prefix": "Priority ",
        "other-prefix": "Other "
    },
    "communications-page": {
        priorities: "Priorities",
        "priority-1": "Priority 1",
        "priority-2": "Priority 2",
        "priority-3": "Priority 3",
        "equipment-in-workshop": "Equipment In Workshop",
        "equipment-to-workshop-by-eos": "Equipment to Workshop by EoS",
        "weekly-comms": "Weekly Comms",
        "shift-comms": "Shift Comms",
        "equipment-and-tasks": "Equipment & Tasks"
    },
    "add-any-staff": {
        "temporarily-add-staff-from-another-crew-into-this-shift": "Temporarily add staff from another crew into this shift"
    },
    "add-any-staff-to-crew": {
        "permanently-move-staff-from-another-crew-into-this-crew": "Permanently move staff from another crew into this crew",
        "add-staff-to-crew-and-week": "Add Staff to Crew and Week"
    },
    "board-warnings-dialog": {
        "no-warnings": "No Warnings"
    },
    "bring-forward-dialog": {
        "there-are-no-planned-tasks-to-bring-forward": "There are no planned tasks to bring forward",
        "this-shift-is-already-fully-planned": "This shift is already fully planned",
        "bring-forward": "Bring forward",
        "will-move-from": "will move from"
    },
    "previous-shift-dialog": {
        "no-tasks": "No Tasks",
        "did-not-fire": "Did not Fire"
    },
    "board-filter-and-sort-drawer-section": {
        clear: "Clear",
        "show-empty": "Show Empty {term}"
    },
    "equipment-drawer": {
        "finish-assigning": "Finish assigning {name} first.",
        equipment: "Equipment",
        "unresourced-tasks": "Unresourced Tasks",
        "hide-unavailable": "Hide unavailable {term}",
        "highlight-unresourced-tasks": "Highlight unresourced tasks"
    },
    "event-logs": {
        "event-log": "Event Log",
        "event-logs": "Event Logs"
    },
    "shift-side-drawer": {
        baselines: "Baselines",
        "event-logs": "Event Logs",
        meetings: "Meetings",
        "shift-handover-meeting": "Shift Handover Meeting",
        "shift-handover": "Shift Handover",
        "shift-deployment-meeting": "Shift Deployment Meeting",
        "shift-deployment": "Shift Deployment",
        "filters-and-groups": "Filters and Groups",
        filters: "Filters",
        grouping: "Grouping",
        columns: "Columns",
        groupings: "Groupings",
        "shift-sidedrawer": "Shift Sidedrawer"
    },
    "equipment-availability-bar": {
        unavailable: "Unavailable"
    },
    "resource-chart": {
        "primary-equipment-utilisation": "Percentage utilisation of primary {term} in this shift",
        "secondary-equipment-utilisation": "Percentage utilisation of secondary {term} in this shift",
        "support-equipment-utilisation": "Percentage utilisation of support {term} in this shift",
        "resources-chart": "Resources Chart",
        "resource-utilisation": "Resource Utilisation",
        "percentage-utilisation-of-crew-members-in-shift": "Percentage utilisation of crew-members in this shift"
    },
    "location-tasks-card": {
        "no-resource-tasks": "No {resource} tasks. Assign directly to tasks instead.",
        "assign-to-all-resource-tasks": "Assign to all {resource} tasks.",
        no: "No {term}",
        commentary: "Commentary",
        "add-hazard": "Add Hazard",
        "assign-to-all-term": "Assign to all {term}",
        "cannot-auto-assign-based-on-role": "Cannot auto-assign based on role. Assign directly to {term} instead."
    },
    baselines: {
        "hide-baseline": "Hide Baseline",
        baselines: "Baselines",
        "enter-actuals": "Enter Actuals"
    },
    "supervisor-printer": {
        print: "Print",
        "print-supervisor-report": "Print Supervisor Report"
    },
    "condition-monitoring": {
        "condition-monitoring": "Condition Monitoring",
        location: "Location",
        time: "Time",
        activity: "Activity",
        action: "Action"
    },
    "delays-and-down-times": {
        "delays-and-downtime": "Delays And Downtime",
        issue: "Issue",
        hours: "Hours"
    },
    "miscellaneous-tasks": {
        "miscellaneous-tasks": "Miscellaneous Tasks",
        location: "Location",
        task: "Task",
        physicals: "Physicals",
        unit: "Unit",
        comments: "Comments"
    },
    "planned-equipment": {
        operator: "Operator",
        level: "Level",
        location: "Location",
        task: "Task",
        details: "Details"
    },
    "shift-manning": {
        "shift-manning": "Shift Manning",
        "safe-stops": "Safe Stops",
        hrs: "Hrs",
        total: "TOTAL:"
    },
    "supervisor-equipment-downtime-tab": {
        "add-term-downtime": "Add {term} Downtime",
        downtime: "Downtime",
        "add-downtime": "Add {term} Downtime",
        select: "Select {term}",
        "select-reason": "Select reason",
        "minutes-downtime": "Minutes Downtime",
        comment: "Comment",
        "add-equipment-downtime": "Add {term}",
        "must-be-at-least-15-minutes": "Must be at least 15 minutes"
    },
    "supervisor-staff-and-equipment-tab": {
        "no-more-than-hours": "No more than {hours} hours.",
        "safe-stops": "Safe Stops",
        "shift-manning": "Shift Manning",
        prestart: "PreStart",
        hazards: "Hazards",
        hours: "Hours",
        "hours-worked": "Hours Worked"
    },
    "variance-to-plan": {
        "variance-to-plan": "Variance (to plan)",
        area: "Area",
        priority: "Priority",
        comments: "Comments",
        unavailable: "Unavailable"
    },
    "in-place-task-quantity-update": {
        quantity: "Quantity:",
        "chainage-label": "Chainage:",
        start: "Start",
        end: "End",
        confirm: "Confirm"
    },
    "key-physical-targets": {
        "week-level-targets": "Week-level Targets: Week Starting {weekStart}",
        "key-physical-targets": "Key Physical Targets",
        "project-level-targets": "Project-level Targets",
        "import-targets": "Import Targets",
        "key-physical-targets-term": "{term} Targets",
        "month-level-targets": "Month-level Targets",
        "no-weekly-targets": "There are no weekly targets. Would you like to generate them?",
        "generate-targets": "Generate Targets",
        "metres-advanced": "Metres Advanced",
        "tonnes-bogged": "Tonnes Bogged",
        "tonnes-fired": "Tonnes Fired"
    },
    "manual-planning-drawer": {
        planning: "Planning",
        "finish-planning-current-task": "Finish planning current task...",
        loading: "Loading...",
        "choose-planning-type": "Choose planning type",
        "no-cycles": "No cycles",
        "no-tasks": "No tasks"
    },
    "planning-drawer": {
        "remove-name": "Remove {name}",
        planning: "Planning",
        "show-suggested-tasks": "Show suggested tasks",
        "show-all-tasks": "Show all tasks",
        "show-all-blast-packet-tasks": "Show all blast packet tasks",
        "finish-planning-current-task": "Finish planning current task...",
        loading: "Loading...",
        "only-show-suggested-ring-tasks": "Only show suggested ring tasks",
        "show-all-ring-tasks": "Show all ring tasks",
        "only-show-suggested-blast-packet-tasks": "Only show suggested blast packet tasks (hides tasks if not all rings are charged)",
        "no-rings": "No rings"
    },
    screen: {
        bog: "Bog",
        drill: "Drill"
    },
    account: {
        "back-to-board": "Back to Board",
        "my-account": "My Account",
        "change-password": "Change Password",
        "current-password": "Current password",
        "new-password": "New password",
        "new-password-again": "New password again",
        change: "Change"
    },
    admin: {
        "back-to-board": "Back to Board",
        "super-admin": "Super Admin",
        "fix-users": "FIX USERS"
    },
    callback: {
        "logging-you-in": "Logging you in...",
        "logging-you-in-error": "An error occurred while logging you in, please try again"
    },
    error404: {
        "page-not-found": "Page not found"
    },
    home: {
        begin: "Begin",
        logout: "Logout",
        login: "Login"
    },
    login: {
        "taking-you-to-the-login-screen": "Taking you to the login screen..."
    },
    logout: {
        "logging-you-out": "Logging you out..."
    },
    "import-reporting-months-dialog": {
        line: "Line {number}",
        "month-template": "Month {month}",
        "import-reporting-months": "Import Reporting Months",
        validate: "Validate",
        "import-file-details": "Import File Details",
        "to-aid-in-importing": "To aid in importing reporting months, please download the template.",
        "each-line-corresponds": "Each line in the import file corresponds to a single reporting month.",
        year: "Year",
        "year-description": ": The year of the reporting month.",
        month: "Month",
        "month-description": ": The month number (1-12).",
        "start-date": "Start Date",
        "start-date-description": ": The start date of the reporting month in format YYYY-MM-DD.",
        "end-date": "End Date",
        "end-date-description": ": The end date of the reporting month in format YYYY-MM-DD.",
        "import-issues": "There are one or more issues with your import. Please resolve before continuing",
        "import-warning": "There may have been issues with your import",
        "unknown-error": "Unknown Error"
    },
    "production-front-overlay-card": {
        "overlay-name": "Overlay Name"
    },
    staff: {
        "active-term": "Active {term}",
        "archived-term": "Archived {term}",
        "cannot-import-no-staff-roles-available": "Cannot import: No staff roles available.",
        "archiving-removes-from-crew": "Archiving a staff member removes them from their crew but will not affect historical assignments.",
        "archive-staff-member": "Archive staff member?",
        "restoring-not-add-to-crew": "Restoring a staff member will not add them back to their crew.",
        "restore-archived-staff-member": "Restore archived staff member?"
    },
    "stope-tarp-history-dialog": {
        "changed-at": "Changed At",
        "changed-by": "Changed By",
        comments: "Comments"
    },
    "report-viewer": {
        "refreshes-exhausted": "Refreshes exhausted. Refreshes will reset: {resetAt}",
        "last-refreshed": "Last refreshed {dateTime}",
        "refreshes-will-reset-at": "Refreshes will reset at {dateTime}",
        refresh: "Refresh",
        "no-permission-to-refresh-reports": "You do not have permission to refresh reports.",
        "last-refresh-running-longer-than-expected": "Last refresh running longer than expected...",
        "refreshes-nearing-limit": "Refreshes Nearing Limit",
        "fewer-than-2-refreshes-remaining": "You have fewer than 2 or fewer refreshes remaining.",
        "are-you-sure-wish-to-refresh": "Are you sure you wish to refresh?",
        "refresh-queued": "Refresh Queued"
    },
    "offline-button": {
        "no-connection": "No Connection",
        "internet-connection-not-active": "Your internet connection is not currently active. If this is only temporary please wait a moment and this page will become accessible again."
    },
    "shift-inspections": {
        attachments: "Attachments",
        "view-attachments": "View Attachments",
        "reported-by": "Reported By",
        "reported-at": "Reported At"
    },
    "copy-shift-crew-assignments-dialog": {
        crews: "Crews: {crews}",
        "this-will-result-in-the-following-changes": "This will result in the following changes:",
        copy: "Copy"
    },
    "import-week-plan-dialog": {
        "manual-cycle-name": "Manual Cycle - {name}",
        "adhoc-cycle-name": "AdHoc Cycle - {name}",
        "adhoc-task-name": "AdHoc Task- {name}",
        line: "Line {number}",
        "import-plan": "Import Plan",
        validate: "Validate",
        "import-file-details": "Import File Details",
        "help-intro": "To aid in importing a plan, please download the template.",
        "help-each-line": "Each line in the import file corresponds to either a single task, or an entire cycle of work.",
        "col-location": "Location",
        "col-location-desc": ": Name of the location in which to plan work.",
        "col-priority": "Priority",
        "col-priority-desc": ": Planning priority to assign this location in this week. Must be a non-negative whole number.",
        "col-target-cycles": "Target Cycles (optional)",
        "col-target-cycles-desc": ": The number of cycles intended to be completed in this week. Must be a non-negative whole number.",
        "col-target-start-shift": "Target Start Shift",
        "col-target-start-shift-desc": ": Name of the shift the work should start in. Must be in format \"[Day of Week] [Shift Name]\". E.g. \"Mon Night\"",
        "col-start-time": "Start Time (optional)",
        "col-start-time-desc-1": ": Time of day the work should start in. Must fall in the",
        "col-start-time-desc-2": "and be in 24-hour format. If omitted, defaults to the beginning of the shift.",
        "col-import-type": "Import Type",
        "col-import-type-desc-1": ": The type of work being imported. Must be \"Task\", \"Cycle\", or \"AdHoc\". \"Task\" is used for importing either individual tasks, or building manual cycles of work (together with the",
        "col-import-type-desc-2": ". \"Cycle\" is used for importing predefined cycles of work. \"AdHoc\" is used for importing tasks ad-hoc tasks such as Services or Maintenance.",
        "col-cycle-id": "Cycle Id",
        "col-cycle-name": "Cycle Name",
        and: "and",
        "col-duration": "Duration (required for AdHoc and Task imports)",
        "col-duration-desc": ": The duration, in increments of 15 minutes, of the planned work. Will be rounded down if not in 15 minute increments.",
        "col-task-name": "Task Name (required for AdHoc and Task imports)",
        "col-task-name-desc": ": The name of the predefined task type the work belongs to.",
        "col-cycle-name-full": "Cycle Name (required for Cycle and AdHoc Cycle imports)",
        "col-cycle-name-desc": ": For Cycle imports, this is the name of the predefined cycle of work to plan. Must also be specified if planning a manual cycle (including AdHoc cycles), in which case in may either be the name of a predefined cycle of work to associate the manual cycle with, or a brand new name. Must be 50 characters or fewer.",
        "col-cycle-name-abbr": "Cycle Name Abbreviation (optional)",
        "col-cycle-name-abbr-desc": ": When planning manual cycles of work, provides an abbreviation of the cycle name for display in small spaces. Must be 20 characters or fewer.",
        "col-cycle-id-optional": "Cycle Id (optional)",
        "col-cycle-id-desc": ": Used to group Task imports within the file as a single manual cycle. Can also be used to add new tasks to existing manual cycles from the previous week.",
        "col-cycle-fg-colour": "Cycle Foreground Colour (optional)",
        "col-cycle-fg-colour-desc": ": When specifying a manual cycle (including AdHoc cycles), specifies the colour of the cycle's text in the UI. Must be a valid CSS colour.",
        "col-cycle-bg-colour": "Cycle Background Colour (optional)",
        "col-cycle-bg-colour-desc": ": When specifying a manual cycle (including AdHoc cycles), specifies the colour of the cycle in the UI. Must be a valid CSS colour.",
        "col-quantity": "Quantity (required for Rate-based Tasks)",
        "col-quantity-desc": ": Used to assign a quantity to a Task import. E.g. \"Metres to be Drilled\".",
        "col-ring-name": "Ring Name (optional)",
        "col-ring-name-desc": ": Used to indicate a Task is in service of advancing a ring to the point of blasting.",
        "col-blast-packet-name": "Blast Packet Name (optional)",
        "col-blast-packet-name-desc": ": Used to indicate a Task is in service of Blasting or Bogging a blast packet.",
        "col-equipment-name": "Equipment Name (optional)",
        "col-task-priority": "Task Priority (optional)",
        "col-task-priority-desc": ": Used with AdHoc imports to assign a Task Priority.",
        "col-location-name-override": "Location Name Override (optional)",
        "col-location-name-override-desc": ": Used with AdHoc imports to override the location name.",
        "col-task-name-override": "Task Name Override (optional)",
        "col-task-name-override-desc": ": Used with AdHoc imports to override the task name.",
        "col-description": "Description (optional)",
        "col-description-desc": ": Used with AdHoc imports to provide a task description.",
        "col-consumables": "Consumables (optional)",
        "col-consumables-desc": ": Used with AdHoc imports to provide a list of consumables.",
        "equipment-name-label": "Equipment Name:",
        "quantity-label": "Quantity:",
        "ring-bp-label": "Ring/BP:",
        "location-override-label": "Location Override:",
        "task-override-label": "Task Override:",
        "consumables-label": "Consumables:",
        "effort-minutes-label": "Effort (Minutes):",
        "description-label": "Description:",
        "issues-with-plan": "There are one or more issues with your plan. Please resolve before continuing",
        "issues-with-import": "There may have been issues with your import",
        "unknown-error": "Unknown Error"
    },
    "week-side-drawer": {
        baselines: "Baselines",
        "stop-showing-baseline": "Stop Showing Baseline",
        "enable-historic-edit": "Enable Historic Edit",
        "filters-and-groups": "Filters and Groups",
        filters: "Filters",
        grouping: "Grouping",
        columns: "Columns",
        groupings: "Groupings",
        "allow-movement": "Allow Movement",
        "are-you-sure-move-historic-cycles": "Are you sure you want to move historic cycles? This will affect actuals! You should only use this if a cycle was erroneously moved to the past"
    },
    "auto-board-refresher": {
        "auto-refresh-mode": "Auto-refresh Mode"
    },
    "resource-levelling-hint-menu": {
        "clear-override": "Clear override",
        "contributing-work": "Contributing Work",
        "under-resourced-title": "Under-resourced",
        "over-resource-target-title": "Over resource target",
        "under-utilised-title": "Under-utilised",
        "no-crew-title": "No crew",
        "no-resources-title": "No resources",
        "under-resourced-message-1": "Not enough hours of effort available in this shift.",
        "under-resourced-message-2": "Try adding staff able to perform this type of work to the shift, or moving some tasks to other shifts.",
        "over-resource-target-message-1": "Hours of effort required for this work type exceed the resourcing percentage target.",
        "over-resource-target-message-2": "If this is a problem, try adding staff able to perform this type of work to the shift, or moving some tasks to other shifts.",
        "under-utilised-message-1": "Hours of effort are below the under-utilisation percentage. This may mean you have staff under-used.",
        "under-utilised-message-2": "Try moving some tasks into this shift from other shifts.",
        "no-crew-message-1": "There is no crew assigned to this shift.",
        "no-crew-message-2": "To see the resourcing status, assign crew to the shift.",
        "no-resources-message-1": "There are no staff available in this shift able to perform this type of work.",
        "no-resources-message-2": "Add staff to the shift, or remove all tasks of this type from the shift.",
        "acceptable-message": "Resourcing acceptable.",
        "overridden-suffix": " (overridden)",
        "tooltip-no-crew": "No crew assigned yet.",
        "tooltip-no-resources": "No resources available for this work type. {requiredHours} hours required.",
        "tooltip-over-resource-target": "Over resourcing target. {availableHours} hours{overridden} available, {requiredHours} hours required.",
        "tooltip-over-resource-availability": "Insufficient resources of this type available. {availableHours} hours{overridden} available, {requiredHours} hours required.",
        "tooltip-under-utilised": "Resources are underutilised. {availableHours} hours{overridden} available, {requiredHours} hours required.",
        "tooltip-acceptable": "Resourcing acceptable. {availableHours} hours{overridden} available, {requiredHours} hours required."
    },
    "stope-tarp-statuses-list": {
        "last-updated": "Last Updated"
    },
    "production-front-visualisation": {
        "error-loading-overlay": "Error loading overlay {overlay} for level {level}",
        "front-band-path-start": "M {x1},{y1} L {x2},{y2}",
        "diagram-warnings": "Diagram Warnings"
    },
    "summary-tarp-status": {
        "change-status": "Change Status",
        "view-history": "View History"
    },
    "task-information": {
        "shift-plan": "Shift Plan",
        "remaining-actuals": "Remaining Actuals"
    },
    shift: {
        "show-inactive-term": "Show inactive {term}",
        "print-name": "Print {name}",
        "configure-board": "Configure Board",
        "quick-actions": "Quick Actions",
        "frequently-taken-actions": "Frequently Taken Actions",
        "full-activity-names-on-week-board": "Full activity names on Week Board",
        "collapse-grouped-adhoc-tasks-alt-y": "Collapse grouped adhoc tasks (Alt+Y)",
        "saving-changes": "Saving changes…",
        language: "Language",
        "no-next-shift-planned": "No next shift planned",
        "24-hour-view": "24-Hour View",
        "single-shift-view": "Single Shift View",
        "generate-week-targets": "Generate Week Targets",
        "manual-planning": "Manual Planning",
        "print-pack": "Print Pack",
        "print-screen": "Print Screen",
        "screenshot-screen": "Screenshot Screen",
        "variance-report": "Variance Report",
        "to-force-speed-dial-to-be-included": "To force speed dial to be included"
    },
    "equipment-in-location-card": {
        commentary: "Commentary",
        "mark-as-serviceable": "Mark as serviceable",
        "mark-as-unserviceable": "Mark as unserviceable",
        "mark-as-not-in-workshop-this-shift": "Mark as not in workshop this shift",
        "mark-as-in-workshop-this-shift": "Mark as in workshop this shift",
        "in-workshop": "In Workshop",
        "mark-as-not-needed-in-workshop-at-eos": "Mark as not needed in workshop at EoS",
        "mark-as-needed-in-workshop-at-eos": "Mark as needed in workshop at EoS",
        "needed-in-workshop": "Needed in Workshop",
        "add-hazard": "Add Hazard",
        "in-workshop-task": "IN WORKSHOP",
        "tram-to-workshop": "TRAM TO WORKSHOP"
    },
    "department-selector": {
        "mine-interactions": "Mine Interactions",
        "mine-interactions-board": "Mine Interactions Board"
    },
    "to-do-action-dialog": {
        "completed-at": "Completed {time}",
        "started-at": "Started {time}",
        "undo-completion": "Undo completion",
        "mark-completed": "Mark completed",
        "add-comment": "Add comment",
        "cannot-remove-comments-offline": "Cannot remove comments whilst offline.",
        "remove-comment": "Remove comment",
        "cannot-delete-tasks-offline": "Cannot delete tasks whilst offline.",
        "delete-task": "Delete task",
        "cannot-edit-tasks-offline": "Cannot edit tasks whilst offline.",
        "edit-task": "Edit task"
    },
    "location-tracker-image-menu": {
        "view-level-map": "View Level Map"
    },
    "priority-analytics": {
        "analytics-date": "Analytics, {date}",
        "analytics-week": "Analytics Week {weekNumber} - {weekOf}",
        "shift-planning-not-started-full": "Planning for this shift has not started. Start planning from the Shift board",
        "week-planning-not-started-full": "Planning for this week has not started. Create a weekly plan before planning this shift"
    },
    "location-task-card": {
        "activity-description": "Activity Description"
    },
    "location-survey-metric-details-dialog": {
        "remove-metric": "Remove {metricName}",
        "confirm-delete-metric": "Do you want to continue and delete this {metricName}?",
        "cannot-delete-whilst-offline": "Cannot delete whilst offline.",
        "remove-chainage": "Remove chainage",
        "no-historical-data-available": "No historical data available.",
        "load-historical-data": "Load Historical Data",
        "this-action-could-affect-figures": "This action could affect calculated figures and reporting.",
        "this-action-will-be-audited": "This action will be audited."
    },
    "shift-crew-selection-menu": {
        "assign-crews": "Assign Crews"
    },
    logo: {
        "ordo-logo": "Ordo Logo"
    },
    "standard-attachment-preview": {
        "upload-name": "Upload {name}",
        sending: "Sending...",
        remove: "Remove",
        "open-for-printing": "Open For Printing"
    },
    "shift-supervisor-page": {
        "staff-and-term": "Staff & {term}",
        "no-crew-selected": "No Crew Selected",
        "safety-and-incidents": "Safety & Incidents",
        "abandon-changes-confirm": "You have made changes on the following tabs that will be lost if you continue without saving them. Abandon changes?"
    },
    "location-extended-properties": {
        "possible-values": "Possible Values",
        "location-property": "Location Property"
    },
    "equipment-card": {
        "mark-as-serviceable": "Mark as serviceable",
        "mark-as-unserviceable": "Mark as unserviceable",
        "mark-as-not-in-workshop-this-shift": "Mark as not in workshop this shift",
        "mark-as-in-workshop-this-shift": "Mark as in workshop this shift",
        "in-workshop": "In Workshop",
        "mark-as-not-needed-in-workshop-at-eos": "Mark as not needed in workshop at EoS",
        "mark-as-needed-in-workshop-at-eos": "Mark as needed in workshop at EoS",
        "needed-in-workshop": "Needed in Workshop",
        "add-hazard": "Add Hazard",
        "in-workshop-task": "IN WORKSHOP",
        "tram-to-workshop": "TRAM TO WORKSHOP"
    },
    row: {
        "unknown-action": "Unknown action: {action}",
        "delete-name": "Delete {name}",
        "are-you-sure-delete-task": "Are you sure you want to delete this task?"
    },
    "set-location-chainage-dialog": {
        "active-from": "Active From",
        "update-chainage-title": "Update Chainage - {name}",
    },
    "set-location-survey-metric-dialog": {
        "active-from": "Active From"
    },
    "in-place-numeric-editor": {
        confirm: "Confirm"
    },
    "location-with-equipment-card": {
        "assign-to-equipment": "Assign to {equipment}.",
        commentary: "Commentary",
        "add-hazard": "Add Hazard",
        "no-term-to-assign-to": "No {term} to assign to.",
        "assign-to-all-term": "Assign to all {term}",
        "multiple-term-allocated": "Multiple {term} allocated. Assign directly to {term} instead."
    },
    "column-filter-and-sort-menu": {
        "group-by": "Group by {columnName}",
        "sort-and-filter": "Sort and Filter",
        ungroup: "Ungroup",
        "sort-ascending": "Sort Ascending",
        "sort-descending": "Sort Descending",
        clear: "Clear",
        okay: "Okay"
    },
    "operator-completion-sheet": {
        "filter-to-operator": "Filter to operator.",
        "manual-plods": "Manual Plods"
    },
    "in-place-time-editor": {
        confirm: "Confirm"
    },
    "reorder-rings-dialog": {
        "term-reorder-dialog": "{term} Reorder Dialog"
    },
    "ring-configurations": {
        "drill-length-avg": "Drill Length (Avg)",
        "charge-amount-avg": "Charge Amount (Avg)"
    },
    "week-visualiser": {
        "collision-between": "Collision between {taskA} ({startA} - {endA}) and {taskB} ({startB} - {endB}) "
    },
    "reduced-levels": {
        "failed-to-upload-term-map": "Failed to upload {term} Map",
        "failed-to-remove-term-map": "Failed to remove {term} Map"
    },
    "location-ring-dialog": {
        "edit-term": "Edit {term}",
        "create-term": "Create {term}",
        "update-term": "Update {term}?",
        "ring-belongs-to-blast-packet": "This {ring} belongs to a {blastPacket}. Would you like to update the {blastPacket} as well?"
    },
    confirm: {
        "delete-resource": "Delete {resourceType}",
        "confirm-delete-resource": "Are you sure you want to delete this {resourceType}?"
    },
    "location-progress": {
        "total-pips-exceed-max": "Total pips should not exceed maxSegments."
    },
    "week-task-contents": {
        "cut-number-text": "Cut #{cutNumber} : {text}"
    },
    "data-table-priority-editor": {
        "update-name": "Update {name}"
    },
    "data-table-property-editor": {
        "update-name": "Update {name}"
    },
    "data-table-select-editor": {
        "update-text": "Update {text}"
    }
};

export default en;
